import React, { Component } from 'react'
import Axios from 'axios';
import qs from 'qs';
import { Input, Modal, Select, Form, DatePicker, notification, Tooltip, Checkbox } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import $ from 'jquery';
import { Link } from "react-router-dom";
import AsideLeft from '../../components/aside/asideleft';
import {
    PATIENT_DATA,
    Get_Obs_Gyane_Data,
    Save_Obs_Gyane_Data,
    // Previous-visit obs/gynae copy (ported from the SOAP Obs & Gynae screen) so landing
    // directly on the ANC page still copies the previous pregnancy's obs/gynae data.
    Get_Previous_Obs_Gyane_Data,
    Get_Obs_Gyane_Copy_Status,
    Update_Obs_Gyane_Copy_Status,
    Save_Menstrual_History,
    Save_Sexual_History,
    Save_Obstetric_History,
    Save_Mother_Parameter_Data,
    Save_Mother_Fetus_Data,
    VaccinationList,
    VaccinationItemList,
    VaccinationAdd,
    VaccinationRecordList,
    VACCINATION_SITES,
    PAEDRATICVACCINEID,
    RISK_FACTORS_LIST,
    OBJECTIVE_GETALL,
    DURATION_TYPE,
    INFORMED_BY,
    MEDICATION_ON,
    FETAL_MOVEMENT,
    PRESENTATION,
    RELATIONSHIP_TO_PP_BRIM,
    LOADER,
    CONCEPTION_OPTIONS,
    PREGNANCY_OPTIONS,
    DELIVERY_OPTIONS,
    OUTCOME_OPTIONS,
    PLACE_OF_DELIVERY_OPTIONS,
    loadObsGynaeMasters,
    ISALLOWEDITSOAP,
    Save_Anc_Details,
    Get_Anc_Details,
    Get_Anc_Previous_Details,
    Get_Anc_Mother_Data_By_Anc,
    Save_Anc_Mother_Print_All,
    Get_Previous_Mother_Fetus_History,
    Print_Anc_Details,

} from "../../utils/constant";
import { speechService, speechTextService, pregnantService } from '../../utils/rxjs-sharing';
import MyHcSpeechRecognition from "../../pages/speech-to-text/speech-recognition";
import LS_SERVICE from "../../utils/localStorage";
import { headerService$ } from '../../utils/rxjs-sharing';
import moment from "moment";
import MultiplePregnancies from './sscomponents/MultiplePregnancies';
import DeliveryDetailsModal from './sscomponents/DeliveryDetailsModal';
import MotherParameterModal from './sscomponents/MotherParameterModal';
import FetusModal from './sscomponents/FetusModal';
import PreviousMotherHistoryModal from './sscomponents/PreviousMotherHistoryModal';
import PreviousPregnancyDetails from './sscomponents/PreviousPregnancyDetails';
import VaccineOptional from './sscomponents/VaccineOptional';
import AncTestProcedures from './sscomponents/AncTestProcedures';
import AncCardView from '../patient-detail/anccardview';
const { Option } = Select;

export default class AncCard extends Component {
    constructor(props) {
        super(props);
        this.ancFormRef = React.createRef();
        this.state = {
        	patientInfo: null,
        	patient_id: null,
        	reference_id: null,
        	anc_id: null,
        	reference_type: null,
        	doctor_id: null,
        	current_allergies : [],
        	current_conditions : [],
        	risk_factors_options: [],
        	pregnancy_risk_factor : [],
      		pregnancy_risk_factor_selected: [],
      		pregnancy_risk_factor_management_remarks : null,
        	vaccineData : [],
        	vaccineItemList : [],
        	vaccinationSites : VACCINATION_SITES,
        	currentPregnancyData : null,
        	speech: {
                identifier: null,
                state: false
            },
            immuno_remarks : null,
            investigation_remarks : null,
            test_procedures_data : [{ title: '', description: '' }],
            conception_options: CONCEPTION_OPTIONS,
            pregnancy_options: PREGNANCY_OPTIONS,
            delivery_options: DELIVERY_OPTIONS,
            outcome_options: OUTCOME_OPTIONS,
            place_of_delivery_options: PLACE_OF_DELIVERY_OPTIONS,
            pregnancy_year : null,
            year_options: [],
            delivery_mode : null,
            pregnancy_type : null,
            delivery_type : null,
            delivery_place : null,
            delivery_outcome : null,
            delivery_bith_date_time : null,
            delivery_gender : null,
            delivery_birth_weight : null,
            delivery_birth_height : null,
            delivery_birth_head_cc : null,
            delivery_congenital_abnormality : false,
            delivery_congenital_abnormality_remarks : null,
            delivery_indication_for_c_section : null,
            delivery_details : null,
            multiple_pregnancies : [],
            allowEdit:false,
            multiplePregnanciesModal: false,
            deliveryDetailsModalVisible: false,
            motherParameterModalVisible: false,
            fetusModalVisible: false,
            previousMotherParameterModalVisible: false,
            previousMotherFetusModalVisible: false,
            previousMotherParameters: [],
            previousMotherFetusData: [],
            // ANC-scoped Mother Parameter + Fetus data (fetched by anc_id). Shows latest 5 by
            // default; "Load more" re-fetches with all=true. "Print all" only affects the print.
            ancMotherParameters: [],
            ancMotherParamTotal: 0,
            ancMotherParamShowAll: false,
            ancMotherFetusRows: [],
            ancMotherFetusBatchTotal: 0,
            ancMotherFetusShowAll: false,
            ancMotherParamPrintAll: false,
            ancMotherFetusPrintAll: false,
            ancMotherDataLoading: false,
            prevAncCardData : [],
            showRxModal: false,
    		rxPdfPath: null,
    		isPrintLoader: false,
    		spin_loading : false,
    		// Patient-level pregnancy flag (drives the Pregnancy Active / Close Pregnancy header).
    		// Initialised from LS and kept live via pregnantService.
    		isPatientPregnant: LS_SERVICE.get('PATIENT_PREGNANT_STATUS') == "1",
        }
    }

    componentDidMount = async () => {
    	loadObsGynaeMasters().then(() => this.setState({ conception_options: CONCEPTION_OPTIONS, pregnancy_options: PREGNANCY_OPTIONS, delivery_options: DELIVERY_OPTIONS, outcome_options: OUTCOME_OPTIONS, place_of_delivery_options: PLACE_OF_DELIVERY_OPTIONS }));
    	const { match: { params } } = this.props;
    	await this.setState({
    		patient_id: params.patient_id,
            reference_id: params.reference_id,
            reference_type: params.reference_type,
            doctor_id: (LS_SERVICE.get('user_type') === 2) ? LS_SERVICE.get('selectedDoctorIdAppoinement') : LS_SERVICE.get('staff_id')
    	});
    	let hospitalConfigData = LS_SERVICE.get('hospitalConfigData')??[];
        hospitalConfigData = hospitalConfigData.find(item=>item.hospital_id==params.hospital_id);

        let allowEdit = hospitalConfigData?ISALLOWEDITSOAP(hospitalConfigData.pres_modification, hospitalConfigData.allow_hours, LS_SERVICE.get('appointmentCompletedTime')[params.reference_id], 'button', LS_SERVICE.get('TIMEZONE_OFFSET_MINUTES')):true;

        this.setState({
            allowEdit,
        }, async () => {
            if (LS_SERVICE.has('hospitalConfigData')) {
                const hospitalConfigData = LS_SERVICE.get('hospitalConfigData');
                let hospitalConfigObj = hospitalConfigData.find(obj => obj.hospital_id == params.hospital_id);
                headerService$.soapConfig({ soapConfig: hospitalConfigObj.opd_layout }); // IMPORTANT TO HIT AS PER THE VIEW
            }
        });
    	let cyear = new Date().getFullYear();
        let syear = cyear - 20;
        let year_options = [];

        for (let i = cyear; i >= syear; i--) {
            year_options.push(i);
        }
        this.setState({
            year_options
        });
    	const ss_configuration = LS_SERVICE.get('ss_configuration');
	    const patient_full_data = LS_SERVICE.get('call_patient_detail');
	    await this.setState({
	        ss_configuration: ss_configuration,
	        consult_type: patient_full_data?.consult_type == 1 ? 'vc' : 'opd'
	    })
    	// Keep the patient pregnancy flag live (e.g. cleared after closing the pregnancy).
    	this.pregnantSubscription = pregnantService.status().subscribe(data => {
            if (data && typeof data.is_pregnant !== 'undefined') {
                this.setState({ isPatientPregnant: data.is_pregnant == "1" });
            }
        });
    	this.subscription = speechTextService.status().subscribe((data) => {
            if (this.state.speech.state) {
                if (this.state.speech.identifier === "pregnancy_risk_factor_management_remarks") {
                    this.ancFormRef?.current?.setFieldsValue({ pregnancy_risk_factor_management_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }
                if (this.state.speech.identifier === "delivery_details") {
                    this.ancFormRef?.current?.setFieldsValue({ delivery_details: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "delivery_indication_for_c_section") {
                    this.ancFormRef?.current?.setFieldsValue({ delivery_indication_for_c_section: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "immuno_remarks") {
                    this.ancFormRef?.current?.setFieldsValue({ immuno_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

                if (this.state.speech.identifier === "delivery_congenital_abnormality_remarks") {
                    this.ancFormRef?.current?.setFieldsValue({ delivery_congenital_abnormality_remarks: data.text });

                    document.querySelector(
                        "#" + this.state.speech.identifier
                    ).style.height =
                        document.querySelector("#" + this.state.speech.identifier)
                            .scrollHeight + "px";
                }

            }
        });
        this.getVaccineItemList(params.hospital_id);
        // Load the core patient + current-pregnancy data first. These drive the header and the
        // Menstrual/Obstetric sections (via currentPregnancyData) and must be set before render,
        // so they run sequentially rather than racing each other's setState calls.
        await this.getPatientData();
        // Load the risk-factor options BEFORE the obs/gynae data so the Pregnancy Risk Factor
        // multi-select has its options available when the saved values are applied; otherwise
        // the selected ids have no matching option and the chips render blank.
        await this.optionRiskFactorsList();
        // Landing directly on the ANC page (without first opening the SOAP Obs & Gynae screen)
        // means the previous pregnancy's obs/gynae data was never copied into THIS reference id,
        // so the Menstrual/Obstetric/Mother/Fetus sections showed up empty. Port the SOAP
        // screen's "copy previous obs/gynae" behaviour here: copy once per reference (guarded by
        // the server copy-status flag) BEFORE loading the current obs/gynae data below, so the
        // copied values are read and rendered the same way as on the SOAP screen.
        await this.copyPreviousObsGyaneDataIfNeeded();
        await this.getPatientObsGyaneData();
        // The rest are independent of each other, so run them together to cut the load time.
        await Promise.all([
            // Pre-fetch patient-level previous mother/fetus history so the "Previous ..." links
            // can be shown only when there is data available.
            this.getPreviousMotherHistory(),
            this.handleObjectiveGetAllData(),
        ]);
        // Loads the active ANC card and sets this.state.anc_id (needed by the calls below).
        await this.getPatientAncDetails();
        // These both depend on the active card being loaded (anc_id / vaccine config), but are
        // independent of each other - run them in parallel so Previous ANC cards no longer wait
        // behind the vaccination-record merge.
        await Promise.all([
            // Merge previously saved vaccines (shared vaccination records) into the vaccine rows.
            this.getSavedVaccinationRecords(),
            this.getPatientAncPreviousDetails(),
        ]);
    }

    // The ANC <Form> is gated by the pregnancy flag and can mount/remount on a render cycle
    // that happens after the obs/gynae data has already loaded. When that fresh form instance
    // mounts, its antd store starts empty, so the Pregnancy Risk Factor + Remarks revert to
    // blank. Re-apply the cached values here whenever the form ref is present, so they are
    // pushed back into the (possibly new) form store. syncAncFormFields no-ops safely if the
    // ref is not ready yet.
    componentDidUpdate(prevProps, prevState) {
        // Only run until the form has been hydrated once with the loaded values. After that we
        // must NOT force values back, or we would clobber the user's live edits (including an
        // intentional clear). _ancFormHydrated is set the first time the restore applies.
        if (this._ancFormHydrated) return;
        if (this._ancRiskFactorFormValues && this.ancFormRef?.current) {
            const current = this.ancFormRef.current.getFieldValue('pregnancy_risk_factor_management_remarks');
            const selected = this.ancFormRef.current.getFieldValue('pregnancy_risk_factor');
            const expectedRemarks = this._ancRiskFactorFormValues.pregnancy_risk_factor_management_remarks;
            const expectedSelected = this._ancRiskFactorFormValues.pregnancy_risk_factor || [];
            const remarksBlank = (current == null || current === '') && (expectedRemarks != null && expectedRemarks !== '');
            const selectBlank = (!selected || selected.length === 0) && expectedSelected.length > 0;
            if (remarksBlank || selectBlank) {
                this.ancFormRef.current.setFieldsValue(this._ancRiskFactorFormValues);
                this._ancFormHydrated = true;
            }
        }
    }

    printAncDetails = async () => {
        // Save the ANC data first so the print always reflects the latest edits. If the save
        // was aborted (e.g. vaccine validation failed), onFinishAncForm returns false — do NOT
        // proceed to print stale/unsaved data; the validation error is already shown.
        const saved = await this.onFinishAncForm("print");
        if (saved === false) {
            return;
        }
        // Re-fetch the ANC card so anc_id (and all saved sections) are current before printing.
        // On a first-ever save the card is created server-side but its id isn't returned by the
        // save response, so this refresh is what gives us a valid anc_id to print.
        await this.getPatientAncDetails();
        // getPatientAncDetails() rebuilds the vaccine checklist from config (getVaccineData),
        // which clears the given/saved vaccine values on screen. Re-merge the saved vaccination
        // records afterward (same order as componentDidMount) so the vaccine rows keep showing
        // their data without needing a manual page refresh.
        await this.getSavedVaccinationRecords();
	    const BODY = {
	    	patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			anc_id: parseInt(this.state.anc_id),
            printed_by : parseInt(LS_SERVICE.get('staff_id')),
	    }
	    await this.setState({ isPrintLoader : true });
	    await Axios.post(Print_Anc_Details, BODY).then(async (response) => {
			if(response.data.status == true)
			{
				await this.setState({ rxPdfPath: response.data.pdf_url, showRxModal: true, });

			} else {
				notification.error({
	                message: "Oops! Something snapped. Please try again.",
	                placement: "topRight",
	            });
			}
	    	await this.setState({ isPrintLoader : false });
	    }).catch(async (err) => {
			notification.error({
                message: "Oops! Something snapped. Please try again.",
                placement: "topRight",
            });
            await this.setState({ isPrintLoader : false });
	    });
    
  	}

    onFinishAncForm = async (submit_type = null) => {
        // Validate vaccine rows (same rules as the Vaccination Record page) before saving.
        const vaccineValidation = this.validateVaccineData();
        if (!vaccineValidation.valid) {
            notification.error({
                message: vaccineValidation.message,
                placement: 'topRight'
            });
            return false;
        }
        // "print" and "close_pregnancy" are chained saves: suppress the intermediate loader
        // and success toast here so only the caller's final message is shown.
        if(submit_type != "print" && submit_type != "close_pregnancy")
        {
          await this.setState({ spin_loading : true });
        }
    	// Capture the user's CURRENT Pregnancy Risk Factor + Remarks edits before refreshing the
    	// obs/gynae data below. getPatientObsGyaneData re-reads these from the DB and would
    	// overwrite the just-made edits with the old saved values — so the save then persisted
    	// the OLD values and the user's change appeared "not saved". We restore the edits after
    	// the refresh so handleSaveObsGyaneData (which reads state) saves what the user entered.
    	const editedRiskFactor = this.state.pregnancy_risk_factor;
    	const editedRiskFactorSelected = this.state.pregnancy_risk_factor_selected;
    	const editedRiskFactorRemarks = this.state.pregnancy_risk_factor_management_remarks;
    	// Refresh the obs/gynae data so the snapshot below captures EVERY mother-parameter
    	// reading recorded this session (multiple readings are allowed), not a stale copy.
    	await this.getPatientObsGyaneData();
    	// Restore the user's risk-factor edits that the refresh above may have reverted. Also
    	// patch currentPregnancyData so the obs_gyane_data snapshot (built from it) embeds the
    	// edited values too, keeping the ANC card snapshot consistent with the obs/gynae save.
    	await this.setState(prevState => ({
    	  pregnancy_risk_factor : editedRiskFactor,
    	  pregnancy_risk_factor_selected : editedRiskFactorSelected,
    	  pregnancy_risk_factor_management_remarks : editedRiskFactorRemarks,
    	  currentPregnancyData : prevState.currentPregnancyData
    	    ? {
    	        ...prevState.currentPregnancyData,
    	        pregnancy_risk_factor : (Array.isArray(editedRiskFactor) ? editedRiskFactor.join() : editedRiskFactor) || null,
    	        pregnancy_risk_factor_management_remarks : editedRiskFactorRemarks || null,
    	      }
    	    : prevState.currentPregnancyData,
    	}));
    	// Only the vaccines actually administered (given on a date, or given outside) are
    	// snapshotted onto the ANC card, so the Previous Card shows a clean, meaningful list.
    	const administeredVaccines = this.getAdministeredVaccines();
    	let anc_details = {
			patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
			reference_type: 0,
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			source: 'OP',
			current_allergies : this.state.current_allergies ? JSON.stringify(this.state.current_allergies) : null,
			current_conditions : this.state.current_conditions ? JSON.stringify(this.state.current_conditions) : null,
			vaccine_data : administeredVaccines.length > 0 ? JSON.stringify(administeredVaccines) : null,
			// Snapshot of the current pregnancy (obs & gynae) data at save time, persisted
			// as JSON in the anc table's obs_gyane_data column. A reference id can have
			// MULTIPLE mother-parameter readings, so persist the full history
			// (mother_parameter_data_all) alongside the latest (mother_parameter_data) so the
			// closed card / print shows every reading, not just the most recent one.
			obs_gyane_data : this.state.currentPregnancyData ? JSON.stringify(this.buildObsGyaneSnapshot()) : null,
			// Investigations remarks -> patient_obs_gyane_anc_cards.investigation_remarks.
			investigation_remarks : this.state.investigation_remarks || null,
			// Title/Description rows for the Investigations section. Stored in
			// patient_obs_gyane_anc_test_procedure_data (keyed by anc_card_id). Only rows with
			// real text are sent; title/description hold rich-text HTML (e.g. <b>bold</b>), so
			// emptiness is checked against the stripped plain text.
			test_procedures_data : (this.state.test_procedures_data || [])
				.filter(row => this.hasRichTextContent(row.title) || this.hasRichTextContent(row.description))
				.map(row => ({
					title : this.hasRichTextContent(row.title) ? row.title : null,
					description : this.hasRichTextContent(row.description) ? row.description : null,
					created_by : LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
				})),
			immuno_remarks : this.state.immuno_remarks,
			pregnancy_year : this.state.pregnancy_year || null,
			delivery_mode : this.state.delivery_mode || null,
			pregnancy_type : this.state.pregnancy_type || null,
			delivery_indication_for_c_section : this.state.delivery_indication_for_c_section || null,
			delivery_details : this.state.delivery_details || null,
			// Gestational age today (label like "38w 2d"), derived from LMP / corrected-or-EDD,
			// so it is persisted on the ANC card and shown on the Previous Card view.
			delivery_gestational_age : this.getGAToday(
				this.state.currentPregnancyData?.menstural_data?.lmp,
				this.state.currentPregnancyData?.corrected_edd || this.state.currentPregnancyData?.edd_by_lmp,
				this.state.currentPregnancyData?.corrected_edd
			) || null,
			created_by : LS_SERVICE.get('staff_id'),
			updated_by : LS_SERVICE.get('staff_id'),
            is_closed : '0',
	    }
	    if(this.state.pregnancy_type != "2")
	    {
	    	anc_details.delivery_type = this.state.delivery_type || null;
			anc_details.delivery_place = this.state.delivery_place || null;
			anc_details.delivery_outcome = this.state.delivery_outcome || null;
			anc_details.delivery_gender = this.state.delivery_gender || null;
			anc_details.delivery_bith_date_time = this.state.delivery_bith_date_time != null ? moment(this.state.delivery_bith_date_time).format('YYYY-MM-DD HH:mm:ss') : null;
			anc_details.delivery_birth_weight = this.state.delivery_birth_weight || null;
			anc_details.delivery_birth_height = this.state.delivery_birth_height || null;
			anc_details.delivery_birth_head_cc = this.state.delivery_birth_head_cc || null;
			anc_details.delivery_congenital_abnormality = this.state.delivery_congenital_abnormality ? 'true' : 'false';
			anc_details.delivery_congenital_abnormality_remarks = this.state.delivery_congenital_abnormality_remarks || null;
	    }
	    else
	    {
	    	anc_details.multiple_pregnancies = this.state.multiple_pregnancies;
	    }
	    let where_condition = {
			patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
			reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
			reference_type: 0,
			hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
			enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
			source: 'OP',
	    }

	    let Params = {
			where_condition,
			anc_details,
	    };
	    // console.log(this.state.vaccineData);
	    // console.log(Params);

	    // return false;
	    // Tracks whether the save succeeded so callers (e.g. Print) can avoid printing stale data.
	    let saveSucceeded = true;
	    await Axios.post(Save_Anc_Details,Params).then(async res => {
            // Persist vaccines to the shared vaccination records (same as Vaccination Record page).
            await this.saveVaccinationData();
            // Re-fetch the shared vaccination records so the just-saved rows pick up their new
            // id (and given-on/site/batch). Rows with id > 0 are locked in render, so this makes
            // an administered vaccine become non-editable immediately without a page reload.
            await this.getSavedVaccinationRecords();
	    	if(submit_type != "print" && submit_type != "close_pregnancy")
            {
                notification.success({
                  message: "Anc card saved successfully",
                  placement: "topRight",
                });
                await this.setState({ spin_loading : false });
            }
            await this.handleSaveObsGyaneData();
	    })
	    .catch(async (error) => {
			notification.error({
				message: 'Something went wrong! Unable to save the data',
				placement: 'topRight'
			})
    		await this.setState({ spin_loading : false });
    		saveSucceeded = false;
	    });
	    // Signal success/failure so Print can decide whether to fetch + print.
	    return saveSucceeded;
    }

    handleSaveObsGyaneData = async () => {
	    let obs_gyane_data = {
	      pregnancy_risk_factor : this.state.pregnancy_risk_factor.length > 0 ? this.state.pregnancy_risk_factor.toString(): null,
	      pregnancy_risk_factor_management_remarks : this.state.pregnancy_risk_factor_management_remarks,
	      updated_by : LS_SERVICE.get('staff_id')
	    }
	    let where_condition = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }

	    let Params = {
	      where_condition,
	      obs_gyane_data,
	    }
	    await Axios.post(Save_Obs_Gyane_Data,Params).then(async res => {
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to save the data',
	        placement: 'topRight'
	      })
	    })
  	}

    disabledPastDate(current) {
        return current && (current > moment());
    }

    handleObjectiveGetAllData = async () => {
        const { patient_id } = this.state;
        const objectiveGetAllPromise = await Axios.get(OBJECTIVE_GETALL({ patient_id }));

        if (objectiveGetAllPromise.data.status) {
            const { data } = objectiveGetAllPromise.data;
            const { details, constants } = data;
            const { allergies, conditions } = details;
            await this.setState({
                current_allergies : allergies.patientAllergies,
                current_conditions : conditions.patientConditions,
            });
        }
    };

    // Returns the promise so callers can `await` it and be sure the options are loaded before
    // applying saved risk-factor values (so the multi-select chips render with labels).
    optionRiskFactorsList() {
        return Axios.get(RISK_FACTORS_LIST).then(async success => {
            if (success?.data?.status == true) {
                await this.setState({ risk_factors_options: success.data.data });
            }
        }).catch(err => console.log(err));
    }

    optionRiskFactorsLoad() {
        if (!this.state.risk_factors_options || this.state.risk_factors_options.length === 0) {
            return (<Option value={0}><span>No Result Found</span></Option>)
        }
        return this.state.risk_factors_options.map((obj, i) => {
            return (<Option key={i} value={parseInt(obj.id)} title={obj.description}>{obj.description}</Option>)
        }, this)
    }

    // Loads the vaccine name (item) master list for the Vaccine Name dropdown.
    // Uses the ANC route's hospital id (falls back to slot_hospital_id / FACILITY_ID).
    getVaccineItemList = (routeHospitalId) => {
        const hospital_id = routeHospitalId || LS_SERVICE.get('slot_hospital_id') || LS_SERVICE.get('FACILITY_ID');
        Axios.post(VaccinationItemList, qs.stringify({ drug_class: PAEDRATICVACCINEID, hospital_id: hospital_id }))
            .then((response) => {
                // Response may be an object like { status, data: [...] } or a plain array.
                // Find the first array in the response values (robust to key/order differences).
                let list = [];
                const data = response?.data;
                if (Array.isArray(data)) {
                    list = data;
                } else if (data && typeof data === 'object') {
                    const values = Object.values(data);
                    const foundArray = values.find(v => Array.isArray(v));
                    list = foundArray || [];
                }
                this.setState({ vaccineItemList: list });
            })
            .catch(err => console.log(err));
    }

    getVaccineData() {
        let totalvaccine_data = []
        let params = { anc: 'active' };
        return Axios.post(VaccinationList, params)
        .then((success) => {
            let totalvaccine = success.data.data;
            let alredyAddedVaccine = [];
            totalvaccine?.map(ele => {
                if (ele.anc == "Y" && !alredyAddedVaccine.includes(ele.vaccinationId)) {
                    let i;
                    for (i = 1; i <= ele.noOfDoses; i++) {
                        totalvaccine_data.push({
                            active: ele.active,
                            anc: ele.anc,
                            name: ele.name + " " + i,
                            noOfDoses: ele.noOfDoses,
                            type: ele.type,
                            vaccinationId: ele.vaccinationId,
                            vaccine_list: ele.vaccine_list,
                            dose_number: i,
                            scheduleDoseNo: i,
                            emr_vaccination_id: ele.id,
                            dose_id: ele.id,
                            // Age window fields (from the vaccine config) used to compute the
                            // Due Now / Missed status, same as the Vaccination Record page.
                            startAge: ele.startAge,
                            startAgeDuration: ele.startAgeDuration,
                            endAge: ele.endAge,
                            endAgeDuration: ele.endAgeDuration,
                            id: 0,
                            reference_id: 0,
                            vaccine_status : "false",
                            vaccine_date : null,
                            given_outside : 0,
                            vac_site : '',
                            item : '',
                            batch : '',
                            expiry_date : null,
                            remark : ''
                        });
                    }
                    alredyAddedVaccine.push(ele.vaccinationId)
                }                
            });
            this.setState({ vaccineData: totalvaccine_data });
        });
    }

    handleModalPopup = async (e, popup) => {
        if (e !== null) e.preventDefault();
        this.setState({
            [popup]: !this.state[popup],
        });
    }

    handleModalSave = async (obj) => {
        if (obj?.multiple_pregnancies != undefined) {
            await this.setState({
                multiple_pregnancies: obj.multiple_pregnancies
            });
        }
        else
        {
        	await this.setState({
                multiple_pregnancies: []
            });
        }
        await this.setState({
            multiplePregnanciesModal: false,
        });

        // console.log(this.state.multiple_pregnancies)
    }

    getPatientData = async () => {
        const { patient_id } = this.state;
        // Return the promise so callers can await patientInfo being set (its patient_id is
        // the canonical id shared with the Vaccination Record page).
        return Axios.get(PATIENT_DATA({ patient_id }))
        .then(async (success) => {
            const patientInfo = {
                ...success.data.data.results,
                qms_token_id: success.data.data.results.qmsToken
                    ? success.data.data.results.qmsToken.qms_token_id
                    : null,
            };
            const isPregnant = patientInfo?.is_pregnant == "1";
            await this.setState({
                patientInfo,
                // Seed the patient-level pregnancy flag from the patient record.
                isPatientPregnant: isPregnant,
            });
            // Persist and broadcast the pregnancy flag so the left sidebar header badge
            // (Pregnant icon) reflects the correct status on first ANC open, without a reload.
            // AsideLeft sources is_pregnant from its own fetch + this live pregnantService stream.
            LS_SERVICE.set('PATIENT_PREGNANT_STATUS', isPregnant ? "1" : "0");
            pregnantService.init({ is_pregnant: isPregnant ? "1" : "0" });
        })
        .catch((err) => console.log(err));
    }

    componentWillUnmount() {
        this?.subscription?.unsubscribe();
        this?.pregnantSubscription?.unsubscribe();
    }

    //Speech
    initSpeech(info) {
        let initialText = '';
        if (info.identifier === 'pregnancy_risk_factor_management_remarks') {
            initialText = this.state.pregnancy_risk_factor_management_remarks != undefined ? this.state.pregnancy_risk_factor_management_remarks : '';
        }
        if (info.identifier === 'delivery_details') {
            initialText = this.state.delivery_details != undefined ? this.state.delivery_details : '';
        }
        if (info.identifier === 'delivery_indication_for_c_section') {
            initialText = this.state.delivery_indication_for_c_section != undefined ? this.state.delivery_indication_for_c_section : '';
        }

        if (info.identifier === 'delivery_congenital_abnormality_remarks') {
            initialText = this.state.delivery_congenital_abnormality_remarks != undefined ? this.state.delivery_congenital_abnormality_remarks : '';
        }

        if (info.identifier === 'immuno_remarks') {
            initialText = this.state.immuno_remarks != undefined ? this.state.immuno_remarks : '';
        }

        if (info.identifier === this.state.speech.identifier) {
            this.setState({
                speech: {
                    identifier: info.identifier,
                    state: !this.state.speech.state,
                    initialText: initialText
                }
            }, () => {
                speechService.init(this.state.speech);
            });
        }
        else {
            this.setState({
                speech: {
                    identifier: this.state.speech.identifier,
                    state: false,
                    initialText: ''
                }
            }, () => {
                speechService.init(this.state.speech);
                setTimeout(() => {
                    this.setState({
                        speech: {
                            identifier: info.identifier,
                            state: true,
                            initialText: initialText
                        }
                    }, () => {
                        speechService.init(this.state.speech);
                    });

                }, 1000);
            });
        }
    }

    // Gestational Age "today" on the basis of LMP & EDD.
    // Preferred: days elapsed since LMP. Fallback (no LMP): derive from EDD, since a
    // term pregnancy is 280 days (40w) from LMP and EDD = LMP + 280 days, so
    // GA today = 280 - days remaining until EDD.
    // Returns a short label like "71w 1d" (empty string when neither is available).
    getGAToday = (lmp, edd, correctedEdd = null) => {
        let totalDays = null;
        // Parse dates as DATE-ONLY (calendar day) so a time/timezone component on the stored
        // value (e.g. an ISO timestamp like "2026-10-02T00:00:00.000Z") can never shift the
        // day and inflate the GA by one. Normalise to YYYY-MM-DD, then diff whole days.
        const today = moment().format('YYYY-MM-DD');
        // Priority: when a CORRECTED EDD exists, GA Today is derived from it
        // (GA = 280 - daysUntilCorrectedEdd). Otherwise use the normal LMP-based
        // calculation, falling back to the (LMP-derived) EDD.
        if (correctedEdd && moment(correctedEdd).isValid()) {
            const daysToEdd = moment(moment(correctedEdd).format('YYYY-MM-DD')).diff(moment(today), 'days');
            totalDays = 280 - daysToEdd;
        } else if (lmp) {
            const lmpMoment = moment(lmp);
            if (lmpMoment.isValid()) {
                totalDays = moment(today).diff(moment(lmpMoment.format('YYYY-MM-DD')), 'days');
            }
        }
        if ((totalDays === null || isNaN(totalDays)) && edd) {
            const eddMoment = moment(edd);
            if (eddMoment.isValid()) {
                const daysToEdd = moment(eddMoment.format('YYYY-MM-DD')).diff(moment(today), 'days');
                totalDays = 280 - daysToEdd;
            }
        }
        if (totalDays === null || isNaN(totalDays) || totalDays < 0) return '';
        const weeks = Math.floor(totalDays / 7);
        const days = totalDays % 7;
        return weeks + 'w ' + days + 'd';
    }

    handleOnPregnancyRiskFactorChange = async (val,props) => {
	    let pregnancy_risk_factor_selected_data = [];
	    await this.setState({
	      pregnancy_risk_factor_selected: val,
	      obs_gyane_change_detected : true
	    });
	    props.forEach(element => {
	      pregnancy_risk_factor_selected_data.push(element.value);
	    });

	    await this.setState({
	      pregnancy_risk_factor: pregnancy_risk_factor_selected_data.join(),
	      obs_gyane_change_detected: true
	    });
	}

    autoHeight = (e) => {
	    if (e)
	    {
	    	e.target.style.height = e.target.scrollHeight + "px";
	    }	
    }  

    handleOnTextChange = async(event) => {
	    const { name, value } = event.currentTarget;
	    await this.setState({
	      [name]: value
	    });
	    // Guard with optional chaining: pregnancy_risk_factor_management_remarks is now a
	    // STATE-controlled field (its Form.Item has no `name`), so the form ref may be null
	    // here; an unguarded call threw and silently broke the onChange so edits were lost.
	    // Other callers (delivery_details, etc.) are still form-controlled and keep syncing.
	    this.ancFormRef?.current?.setFieldsValue({
	      [name]: value
	    });
  	}

    // True when the rich-text HTML has actual visible text once tags/entities are stripped.
    // Used to skip empty Title/Description rows (markup like "<br>"/"&nbsp;") from the save payload.
    hasRichTextContent = (html) => {
        if (!html) return false;
        const text = String(html)
            .replace(/<[^>]*>/g, '')
            .replace(/&nbsp;/g, ' ')
            .trim();
        return text !== '';
    }

    handleVaccineDate = async (date, dateString, index, field) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = moment(date).format("YYYY-MM-DD");
	      prevItems[index]['vaccine_status'] = "true";
	      return { vaccineData: prevItems };
	    });

	    // console.log(this.state.vaccineData);
  	}

    // Generic text/select field update for a vaccine row (batch, remark, etc.)
    handleVaccineFieldChange = async (event, index, field) => {
	    const value = event?.target?.value;
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = value;
	      return { vaccineData: prevItems };
	    });
    }

    // Select (antd) update for a vaccine row (vaccine name/item, vaccination site).
    handleVaccineSelectChange = async (value, index, field) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index][field] = value;
	      return { vaccineData: prevItems };
	    });
    }

    // ACTION "+" : add another editable dose row for the same vaccine (id 0 => new record).
    // Inserted right after the clicked row, cloning the vaccine identity with blank data.
    handleVaccineAddDose = async (index) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      const src = prevItems[index];
	      if (!src) return { vaccineData: prevItems };
	      const newRow = {
	        ...src,
	        id: 0,
	        reference_id: 0,
	        vaccine_status: "false",
	        vaccine_date: null,
	        given_outside: 0,
	        vac_site: '',
	        item: '',
	        batch: '',
	        expiry_date: null,
	        remark: '',
	        staff: null,
	        givenon: null,
	      };
	      const newItems = [...prevItems];
	      newItems.splice(index + 1, 0, newRow);
	      return { vaccineData: newItems };
	    });
    }

    // Validates the vaccine rows using the same rules as the Vaccination Record page.
    // Returns { valid, message }.
    validateVaccineData = () => {
        const rows = this.state.vaccineData || [];
        for (const item of rows) {
            const hasItem = item.item !== '' && item.item != null && item.item != 0;
            const givenOutside = item.given_outside == 1 || item.given_outside === 'on';
            const hasGivenOn = item.vaccine_date != null && item.vaccine_date !== '';
            const label = (item.name || 'vaccine');

            if (hasItem && !hasGivenOn) {
                return { valid: false, message: "Given On is required for " + label + " to proceed" };
            }
            if (givenOutside && !hasGivenOn) {
                return { valid: false, message: "Given On is required for " + label + " to proceed" };
            }
            if (!givenOutside && hasGivenOn && !hasItem) {
                return { valid: false, message: "Given Outside or Vaccine name is required for " + label + " to proceed" };
            }
            const hasExtra = (item.remark !== '' && item.remark != null) || (item.batch !== '' && item.batch != null) || (item.expiry_date != null && item.expiry_date !== '');
            if (hasExtra && !givenOutside && !hasItem) {
                return { valid: false, message: "Vaccine name is required for " + label + " to proceed" };
            }
        }
        return { valid: true, message: null };
    }

    // Returns only the vaccines administered to the patient (given on a date, or given
    // outside) in a compact shape for the ANC snapshot / Previous Card. These mirror the
    // records saved in paediatric_vaccination so the Previous Card can render them directly.
    getAdministeredVaccines = () => {
        return (this.state.vaccineData || [])
            .filter(item =>
                (item.vaccine_date != null && item.vaccine_date !== '') ||
                item.given_outside == 1 || item.given_outside === 'on'
            )
            .map(item => ({
                name: item.name,
                type: item.type,
                dose_number: item.dose_number,
                vaccinationId: item.vaccinationId,
                item: (item.item !== '' && item.item != null) ? item.item : '',
                // Resolved vaccine display name (from the row's vaccine_list, else the shared
                // vaccineItemList) so the Previous Card view can show the name, not the id.
                vac_name: (() => {
                    const selId = item.item;
                    if (selId === '' || selId == null) return '';
                    const fromRow = (Array.isArray(item.vaccine_list) ? item.vaccine_list : []).find(v => String(v.id) === String(selId));
                    if (fromRow) return fromRow.name;
                    const fromList = (this.state.vaccineItemList || []).find(v => String(v.id) === String(selId));
                    return fromList ? fromList.name : '';
                })(),
                vaccine_date: item.vaccine_date ? moment(item.vaccine_date).format('YYYY-MM-DD') : null,
                given_outside: (item.given_outside == 1 || item.given_outside === 'on') ? 1 : 0,
                vac_site: item.vac_site || '',
                batch: item.batch || '',
                expiry_date: item.expiry_date || null,
                remark: item.remark || '',
            }));
    }

    // Saves the vaccine rows to the shared vaccination records (same as Vaccination Record page).
    // Only rows that have a given date or are given outside are persisted.
    saveVaccinationData = async () => {
        const reference_id = parseInt(LS_SERVICE.get('call_patient_qms_token_id'));
        // Use the canonical patient id from PATIENT_DATA (same value the Vaccination Record
        // page uses as patient.patient_id) so records sync both ways. Fall back to call_patient_id.
        const patient_id = parseInt(this.state.patientInfo?.patient_id || LS_SERVICE.get('call_patient_id'));

        const vaccination_data = (this.state.vaccineData || [])
            // Only save vaccines added/edited on THIS ANC page: rows not already saved in the
            // shared record (id 0) that have some data entered. Already-saved rows (id > 0)
            // are locked here and belong to the Vaccination Record, so we don't re-save them.
            .filter(item => (item.id == null || item.id === 0))
            .filter(item => (item.vaccine_date != null && item.vaccine_date !== '') || item.given_outside == 1 || item.given_outside === 'on' || (item.item !== '' && item.item != null && item.item != 0))
            .map(item => ({
                id: item.id || 0,
                // vaccine_id maps to emr_vaccination_id on the backend; use dose_id (config row id)
                // like the Vaccination Record page, not the vaccinationId.
                vaccine_id: item.dose_id || item.emr_vaccination_id,
                vaccinationId: item.vaccinationId,
                vacc_id: item.vaccinationId,
                emr_vaccination_id: item.emr_vaccination_id,
                dose_id: item.dose_id,
                dose_number: item.dose_number,
                scheduleDoseNo: item.scheduleDoseNo || item.dose_number,
                name: item.name,
                type: item.type,
                // Include the vaccine name list so the backend can resolve vac_name.
                vaccine_list: Array.isArray(item.vaccine_list) ? item.vaccine_list : [],
                item: (item.item !== '' && item.item != null) ? item.item : '',
                // Resolve the selected vaccine's display name here too (from the row's
                // vaccine_list, else the shared vaccineItemList) so the backend can store
                // vac_name even when the per-row vaccine_list is empty.
                vac_name: (() => {
                    const selId = item.item;
                    if (selId === '' || selId == null) return '';
                    const fromRow = (Array.isArray(item.vaccine_list) ? item.vaccine_list : []).find(v => String(v.id) === String(selId));
                    if (fromRow) return fromRow.name;
                    const fromList = (this.state.vaccineItemList || []).find(v => String(v.id) === String(selId));
                    return fromList ? fromList.name : '';
                })(),
                givenon: item.vaccine_date ? moment(item.vaccine_date).format('YYYY-MM-DD') : '',
                outside: (item.given_outside == 1 || item.given_outside === 'on') ? 'on' : 0,
                vac_site: item.vac_site || '',
                batch: item.batch || '',
                expiry_date: item.expiry_date || null,
                remark: item.remark || '',
                duedate: item.duedate || null,
                dob: this.state.patientInfo?.dob || null,
                start_age: item.startAge,
                duration: item.startAgeDuration,
                reference_id: reference_id,
                reference_type: 0,
                creted_by: LS_SERVICE.get('staff_id'),
                // The backend save gate checks `allowEdit && outside == 1` for the
                // given-outside case. The Vaccination Chart payload always sends
                // allowEdit: true, so mirror it here so an ANC "given outside" row
                // (which has no item selected) is persisted the same way.
                allowEdit: true,
            }));

        if (vaccination_data.length === 0) {
            return true;
        }

        const PARAMS = {
            vaccination_data: vaccination_data,
            patient_id: patient_id,
            encounter_id: reference_id,
            reference_type: 0,
        };

        try {
            await Axios.post(VaccinationAdd, PARAMS);
            return true;
        } catch (error) {
            notification.error({
                message: 'Something went wrong! Unable to save vaccination data',
                placement: 'topRight'
            });
            return false;
        }
    }

    // Fetches previously saved vaccines and merges given-on/outside/batch/etc. into vaccineData.
    getSavedVaccinationRecords = async () => {
        // Use the canonical patient id from PATIENT_DATA (same value the Vaccination Record
        // page uses) so we read the same shared vaccination rows. Fall back to call_patient_id.
        const patient_id = parseInt(this.state.patientInfo?.patient_id || LS_SERVICE.get('call_patient_id'));
        try {
            const response = await Axios.post(VaccinationRecordList, qs.stringify({ patient_id: patient_id }));
            // VaccinationRecordList returns the records as the object's values (keyed 0,1,2...),
            // matching how VaccinationRecord.js consumes it via Object.values(response.data).
            const saved = Object.values(response.data || {}).filter(v => v && typeof v === 'object' && v.vacc_id !== undefined);
            if (!saved || saved.length === 0) return;

            await this.setState(prevState => {
                const merged = prevState.vaccineData.map(v => {
                    const match = saved.find(s => s.vacc_id == v.vaccinationId && s.dose_number == v.dose_number);
                    if (match) {
                        return {
                            ...v,
                            id: match.id || 0,
                            reference_id: match.reference_id,
                            item: (match.item_id != null && match.item_id !== '') ? String(match.item_id) : '',
                            vaccine_date: match.given_on ? moment(match.given_on).format('YYYY-MM-DD') : null,
                            given_outside: match.given_outside ? 1 : 0,
                            // Normalise site to a string so the Select value matches its String option ids.
                            vac_site: (match.vac_site != null && match.vac_site !== '') ? String(match.vac_site) : '',
                            batch: match.batch || '',
                            expiry_date: match.expiry_date ? moment(match.expiry_date).format('YYYY-MM-DD') : null,
                            remark: match.remarks || '',
                            vaccine_status: (match.given_on || match.given_outside) ? "true" : "false",
                            // Staff who recorded this dose (for the INFO popover) + given date + recorded-on.
                            staff: match.docDetails || null,
                            givenon: match.given_on || null,
                            created_at: match.createdAt || match.created_at || null,
                        };
                    }
                    return v;
                });
                return { vaccineData: merged };
            });
        } catch (error) {
            // Non-blocking.
        }
    }

    // "Given Outside?" checkbox toggle for a vaccine row.
    handleVaccineGivenOutside = async (event, index) => {
	    const value = event.target.checked ? 1 : 0;
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index]['given_outside'] = value;
	      return { vaccineData: prevItems };
	    });
    }

    // Expiry date update for a vaccine row.
    handleVaccineExpiryDate = async (date, dateString, index) => {
	    await this.setState(prevState => {
	      const prevItems = [...prevState.vaccineData];
	      prevItems[index]['expiry_date'] = date ? moment(date).format("YYYY-MM-DD") : null;
	      return { vaccineData: prevItems };
	    });
    }

    // Builds the obs_gyane_data snapshot persisted on the ANC card. A reference id can
    // accumulate multiple mother-parameter readings; ensure the snapshot always carries the
    // FULL history (mother_parameter_data_all) so the closed card / print can list every
    // reading. Falls back to wrapping the single latest reading when the history array is
    // absent, so nothing is lost even for older data.
    buildObsGyaneSnapshot = () => {
        const cpd = this.state.currentPregnancyData;
        if (!cpd) return cpd;
        const snapshot = { ...cpd };
        const hasAll = Array.isArray(snapshot.mother_parameter_data_all) && snapshot.mother_parameter_data_all.length > 0;
        if (!hasAll) {
            // No explicit history array: derive it from the latest single reading (if any)
            // so mother_parameter_data_all is always present in the saved snapshot.
            if (snapshot.mother_parameter_data && Object.keys(snapshot.mother_parameter_data).length > 0) {
                snapshot.mother_parameter_data_all = [snapshot.mother_parameter_data];
            } else {
                snapshot.mother_parameter_data_all = [];
            }
        }
        return snapshot;
    }

    // Applies values to the ANC <Form> once its ref is available. The form only mounts when
    // PATIENT_PREGNANT_STATUS == "1", and data loads can resolve before that render has
    // committed, so a plain setFieldsValue can run against a null ref and silently do nothing
    // (leaving Pregnancy Risk Factors / Remarks blank even when data exists). Retry a few
    // times until the ref exists.
    syncAncFormFields = (values, attempt = 0) => {
        if (this.ancFormRef?.current) {
            this.ancFormRef.current.setFieldsValue(values);
            return;
        }
        if (attempt < 20) {
            setTimeout(() => this.syncAncFormFields(values, attempt + 1), 50);
        }
    }

    // Shared identifiers used by every obs/gynae fetch/save for this patient visit, mirroring
    // the SOAP Obs & Gynae screen's buildWhereCondition so the copied rows key identically.
    buildObsGyaneWhereCondition = () => ({
        patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
        reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
        reference_type: 0,
        hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
        enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
        source: 'OP',
    })

    // Gestational age (weeks/days) today from an EDD: GA = 280 - (days from today to EDD).
    // DATE-ONLY diff so a time/timezone component can't shift the day. Mirrors the SOAP
    // screen's getGestationalAgeFromEdd so the USG GA copied here matches that screen.
    getGestationalAgeFromEdd = (edd) => {
        if (!edd || !moment(edd).isValid()) {
            return { weeks: null, days: null };
        }
        const daysToEdd = moment(moment(edd).format('YYYY-MM-DD')).diff(moment(moment().format('YYYY-MM-DD')), 'days');
        let totalDays = 280 - daysToEdd;
        if (totalDays < 0 || isNaN(totalDays)) {
            return { weeks: 0, days: 0 };
        }
        return { weeks: Math.floor(totalDays / 7), days: totalDays % 7 };
    }

    // GA (weeks/days) from an LMP (whole calendar days, DATE-ONLY). Mirrors the SOAP screen's
    // computeGaFromLmp / the ANC card's getGAToday so GA By LMP is consistent across screens.
    computeGaFromLmp = (lmp) => {
        if (!lmp || !moment(lmp).isValid()) {
            return { weeks: null, days: null };
        }
        const totalDays = moment(moment().format('YYYY-MM-DD')).diff(moment(moment(lmp).format('YYYY-MM-DD')), 'days');
        if (isNaN(totalDays) || totalDays < 0) {
            return { weeks: 0, days: 0 };
        }
        return { weeks: Math.floor(totalDays / 7), days: totalDays % 7 };
    }

    // A reference id may accumulate multiple mother-parameter rows; return the single latest
    // (highest id, else last). Mirrors the SOAP screen's pickLatestMotherParameter.
    pickLatestMotherParameter = (data) => {
        if (Array.isArray(data)) {
            if (data.length === 0) return null;
            const hasIds = data.every(d => d && d.id != null);
            if (hasIds) {
                return data.reduce((latest, cur) => (cur.id > latest.id ? cur : latest), data[0]);
            }
            return data[data.length - 1];
        }
        return data || null;
    }

    // Return the latest fetus batch (one row per fetus_no, highest id), falling back to the
    // legacy "last `count` rows by id" shape. Mirrors the SOAP screen's pickLatestFetusBatch.
    pickLatestFetusBatch = (rows, count) => {
        if (!Array.isArray(rows) || rows.length === 0) return [];
        const hasFetusNo = rows.some(r => r && r.fetus_no != null && r.fetus_no !== '');
        if (hasFetusNo) {
            const latestByFetus = {};
            rows.forEach(r => {
                if (!r) return;
                if (r.fetus_no == null || r.fetus_no === '') return;
                const key = parseInt(r.fetus_no);
                const existing = latestByFetus[key];
                if (!existing || ((r.id != null ? r.id : 0) > (existing.id != null ? existing.id : 0))) {
                    latestByFetus[key] = r;
                }
            });
            return Object.keys(latestByFetus)
                .map(k => parseInt(k))
                .sort((a, b) => a - b)
                .map(k => latestByFetus[k]);
        }
        const ordered = rows.every(r => r && r.id != null)
            ? [...rows].sort((a, b) => a.id - b.id)
            : [...rows];
        const n = parseInt(count);
        if (!isNaN(n) && n > 0 && n <= ordered.length) {
            return ordered.slice(ordered.length - n);
        }
        return ordered;
    }

    // Copies the previous pregnancy's obs/gynae data into the CURRENT reference id when the
    // user lands directly on the ANC page. This is the ANC-page equivalent of the SOAP Obs &
    // Gynae screen's load-time copy (prevRecordedObsGynae -> copyPrevRecordedObsGynae('Y')).
    //
    // Gated exactly like the SOAP screen so it never double-copies or copies the wrong patient:
    //   - patient is Female and PATIENT_PREGNANT_STATUS == "1"
    //   - the server copy-status flag (Get_Obs_Gyane_Copy_Status) is NOT already set
    // On success it re-saves each section under the current reference (same Save_* endpoints
    // and payload shapes the SOAP screen uses) and sets the copy-status flag so a later visit
    // (or the SOAP screen) won't copy again.
    copyPreviousObsGyaneDataIfNeeded = async () => {
        try {
            const isFemale = LS_SERVICE.get('call_patient_detail')?.gender == 'Female';
            const isPregnant = LS_SERVICE.get('PATIENT_PREGNANT_STATUS') == "1";
            if (!isFemale || !isPregnant) {
                return;
            }

            // Only copy once per reference id. The copy-status flag is the single source of
            // truth shared with the SOAP screen, so a copy done on either screen suppresses
            // the other.
            const alreadyCopied = await this.getObsGyaneCopyStatus();
            if (alreadyCopied) {
                return;
            }

            // Fetch the previous pregnancy's obs/gynae snapshot for this patient/visit.
            const prevData = await this.getPreviousObsGyaneData();
            if (!prevData) {
                // Nothing to copy, but still mark the status so we don't re-check every landing.
                await this.setObsGyaneCopyStatus('N');
                return;
            }

            const where_condition = this.buildObsGyaneWhereCondition();
            const staff_id = LS_SERVICE.get('staff_id');

            // ---- Menstrual history ----
            const menstural_src = prevData.menstural_data || {};
            // Prefer the saved LMP; otherwise derive from EDD By LMP (LMP = EDD - 40 weeks).
            let lmp = (menstural_src?.lmp && menstural_src.lmp != null) ? moment(menstural_src.lmp) : null;
            if (!lmp && prevData?.edd_by_lmp && prevData.edd_by_lmp != null) {
                const derived = moment(prevData.edd_by_lmp).subtract(40, 'weeks');
                if (derived.isValid()) lmp = derived;
            }
            const lmpFormatted = lmp ? lmp.format('YYYY-MM-DD') : null;
            const menstural_data = {
                menarch_age: menstural_src?.menarch_age || null,
                regularity: menstural_src?.regularity || null,
                flow: menstural_src?.flow || null,
                lmp: lmpFormatted,
                bleeding_days: menstural_src?.bleeding_days || null,
                cycle_length: menstural_src?.cycle_length || null,
                menstrual_remarks: menstural_src?.menstrual_remarks || null,
                created_by: staff_id,
                updated_by: staff_id,
            };

            // ---- Sexual history ----
            const sexual_src = prevData.sexual_data || {};
            const sexual_data = {
                sexually_active: sexual_src?.sexually_active || null,
                marital_status: sexual_src?.marital_status || '1',
                spouse_name: sexual_src?.spouse_name || null,
                since: (sexual_src?.since !== '' && sexual_src?.since != null) ? sexual_src.since : null,
                since_by: sexual_src?.since_by || 4,
                married_life: sexual_src?.married_life || null,
                contraceptives: (sexual_src?.contraceptives && sexual_src?.contraceptives != "" && sexual_src?.contraceptives != null) ? sexual_src.contraceptives : null,
                contraceptive_remarks: sexual_src?.contraceptive_remarks || null,
                remarks: sexual_src?.remarks || null,
                sexual_history_data_confidential: sexual_src?.sexual_history_data_confidential || '0',
                remarks_confidential: sexual_src?.remarks_confidential || '0',
                created_by: staff_id,
                updated_by: staff_id,
            };

            // ---- Obstetric history ----
            const obs_src = prevData.obstetric_data || {};
            const obstetric_data = {
                gravidity: obs_src?.gravidity || null,
                parity: obs_src?.parity || null,
                abortion: obs_src?.abortion || null,
                live_birth: obs_src?.live_birth || null,
                ectopic: obs_src?.ectopic || null,
                lscs: obs_src?.lscs || null,
                miscarriage: obs_src?.miscarriage || null,
                mtp: obs_src?.mtp || null,
                preterm: obs_src?.preterm || null,
                term: obs_src?.term || null,
                still_birth: obs_src?.still_birth || null,
                confidential: obs_src?.confidential || '0',
                created_by: staff_id,
                updated_by: staff_id,
            };

            // ---- Obs/gynae parent row ----
            // GA By LMP is recomputed from the (possibly derived) LMP; GA By USG from the
            // Corrected EDD, both for "today" so they stay correct after copy.
            const gaLmp = this.computeGaFromLmp(lmpFormatted);
            const copied_corrected_edd = (prevData?.corrected_edd && prevData.corrected_edd != null) ? moment(prevData.corrected_edd).format('YYYY-MM-DD') : null;
            const gaUsg = this.getGestationalAgeFromEdd(copied_corrected_edd);
            // No. of Fetus strictly reflects the actual count of fetus rows copied.
            const prevFetusBatch = this.pickLatestFetusBatch(prevData?.mother_fetus_data, prevData?.no_of_fetus);
            const copied_no_of_fetus = prevFetusBatch.length > 0 ? prevFetusBatch.length : null;
            const obs_gyane_data = {
                pregnant: prevData?.pregnant || '0',
                edd_by_lmp: (prevData?.edd_by_lmp && prevData.edd_by_lmp != null) ? moment(prevData.edd_by_lmp).format('YYYY-MM-DD') : null,
                corrected_edd: copied_corrected_edd,
                lactating: prevData?.lactating || '0',
                confirmed_by: (prevData?.confirmed_by && prevData?.confirmed_by != "" && prevData?.confirmed_by != null) ? prevData.confirmed_by : null,
                gestational_age_by_lmp_weeks: gaLmp.weeks,
                gestational_age_by_lmp_days: gaLmp.days,
                gestational_age_by_usg_weeks: gaUsg.weeks,
                gestational_age_by_usg_days: gaUsg.days,
                pregnancy_risk_factor: (prevData?.pregnancy_risk_factor && prevData?.pregnancy_risk_factor != "" && prevData?.pregnancy_risk_factor != null) ? prevData.pregnancy_risk_factor : null,
                pregnancy_risk_factor_management_remarks: prevData?.pregnancy_risk_factor_management_remarks || null,
                any_previous_complications: prevData?.any_previous_complications || '0',
                any_previous_complication_details: (prevData?.any_previous_complication_details && prevData?.any_previous_complication_details != "" && prevData?.any_previous_complication_details != null) ? prevData.any_previous_complication_details : null,
                obstetric_remarks: prevData?.obstetric_remarks || null,
                no_of_fetus: copied_no_of_fetus,
                mother_fetal_print_with_prescription: prevData?.mother_fetal_print_with_prescription || '0',
                created_by: staff_id,
                updated_by: staff_id,
            };

            // ---- Mother parameters (latest row only) ----
            const mp = this.pickLatestMotherParameter(prevData.mother_parameter_data);
            const mother_parameter_data = {
                pog: gaLmp.weeks != null ? gaLmp.weeks : (mp?.pog || null),
                // Weight/BP/pulse are visit-specific vitals on the SOAP screen; do not copy.
                weight: null,
                blood_pressure: null,
                pulse_rate: null,
                fundal_height: mp?.fundal_height || null,
                edema: mp?.edema || null,
                pallor: mp?.pallor || null,
                cervix_exam: mp?.cervix_exam || null,
                preterm_labour: mp?.preterm_labour || null,
                mother_remarks: mp?.mother_remarks || null,
                // Copy creates a fresh row for this reference (no existing id to update).
                id: null,
                saved_by_doctor_id: staff_id,
                saved_by_doctor_name: LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
                created_by: staff_id,
                updated_by: staff_id,
            };

            // ---- Fetus details (latest batch only, new rows) ----
            const mother_fetal_parameters = prevFetusBatch.map((ele, idx) => ({
                fetus_no: (ele.fetus_no != null && ele.fetus_no !== '') ? ele.fetus_no : (idx + 1),
                fetal_movement: ele.fetal_movement,
                fetal_heart_rate: ele.fetal_heart_rate,
                presentation: ele.presentation,
                relationship_of_pp_to_brim: ele.relationship_of_pp_to_brim,
                head_cc: ele.head_cc,
                abdominal_cc: ele.abdominal_cc,
                femur_length: ele.femur_length,
            }));
            const mother_fetus_data = {
                mother_fetal_parameters: obs_gyane_data.pregnant == "1" ? mother_fetal_parameters : [],
                saved_by_doctor_id: staff_id,
                saved_by_doctor_name: LS_SERVICE.get('profile')?.data?.full_name || ("Dr. " + LS_SERVICE.get('staff_name')),
                created_by: staff_id,
                updated_by: staff_id,
            };

            // Persist each section under the current reference. Order mirrors the SOAP screen.
            await Axios.post(Save_Obs_Gyane_Data, { where_condition, obs_gyane_data });
            await Axios.post(Save_Menstrual_History, { where_condition, menstural_data });
            await Axios.post(Save_Sexual_History, { where_condition, sexual_data });
            await Axios.post(Save_Obstetric_History, { where_condition, obstetric_data });
            await Axios.post(Save_Mother_Parameter_Data, { where_condition, mother_parameter_data });
            if (obs_gyane_data.pregnant == "1" && mother_fetal_parameters.length > 0) {
                await Axios.post(Save_Mother_Fetus_Data, { where_condition, mother_fetus_data });
            }

            // Mark copied so neither this page nor the SOAP screen copies again.
            await this.setObsGyaneCopyStatus('Y');
        } catch (error) {
            // Non-blocking: a copy failure must not prevent the ANC page from loading. The
            // current obs/gynae fetch still runs next and renders whatever exists.
        }
    }

    // Reads the per-reference obs/gynae copy-status flag. Returns true when a copy has
    // already been recorded (copy_prev_obs_gyane_status == '1'), false otherwise.
    getObsGyaneCopyStatus = async () => {
        const Params = {
            patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
            reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
            reference_type: 0,
        };
        try {
            const res = await Axios.post(Get_Obs_Gyane_Copy_Status, Params);
            return res?.data?.status == true && res.data.data?.copy_prev_obs_gyane_status == '1';
        } catch (error) {
            // On error, assume not copied is unsafe (could double-copy), so treat as copied
            // to avoid writing duplicate rows when the status can't be confirmed.
            return true;
        }
    }

    // Fetches the previous pregnancy's obs/gynae snapshot for this patient/visit, or null.
    getPreviousObsGyaneData = async () => {
        try {
            const res = await Axios.post(Get_Previous_Obs_Gyane_Data, this.buildObsGyaneWhereCondition());
            if (res?.data?.status == true && res.data.data) {
                return res.data.data;
            }
            return null;
        } catch (error) {
            return null;
        }
    }

    // Records the per-reference obs/gynae copy-status flag (same endpoint the SOAP screen uses).
    setObsGyaneCopyStatus = async (value) => {
        const params = {
            reference_id: LS_SERVICE.get('call_patient_qms_token_id'),
            reference_type: LS_SERVICE.get('reference_type'),
            status: value,
        };
        try {
            await Axios.post(Update_Obs_Gyane_Copy_Status, params);
        } catch (error) {
            // Non-blocking.
        }
    }

    getPatientObsGyaneData = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }
	    await Axios.post(Get_Obs_Gyane_Data,Params).then(async res => {
			// Show the current-pregnancy section (mother parameters / fetus details) based on the
			// obs/gynae data's OWN pregnant flag, which comes from this same fetch and is reliable
			// on first load. (Previously this also required the volatile PATIENT_PREGNANT_STATUS
			// localStorage flag, which could still be stale/unset during the initial ANC load —
			// causing the mother parameter/fetus details to intermittently not render until a
			// manual refresh.) The "pregnancy closed" case is handled separately in
			// getPatientAncDetails: when there is no OPEN ANC card it clears currentPregnancyData,
			// which runs after this and reflects the authoritative is_closed status.
			if(res.data.status == true && res.data.data?.pregnant == "1")
			{
				await this.setState({
					currentPregnancyData : res.data.data
				});

				const obs_gyane_data = res.data.data;
				if(obs_gyane_data)
				{
					// Parse the saved comma-separated risk factor ids into the selected-id array,
					// store in state, and sync the form via a mount-safe helper. The ANC <Form>
					// is gated by PATIENT_PREGNANT_STATUS and may not be mounted when this load
					// resolves; calling setFieldsValue against a null ref silently no-op'd, which
					// left Pregnancy Risk Factors + Remarks blank even though data existed.
					let pregnancy_risk_factor_selected = [];
					const saved_risk_factor = obs_gyane_data?.pregnancy_risk_factor;
					if (saved_risk_factor != null && saved_risk_factor !== "") {
						pregnancy_risk_factor_selected = String(saved_risk_factor)
							.split(',')
							.map(v => parseInt(v))
							.filter(v => !isNaN(v));
					}
					const pregnancy_risk_factor_management_remarks = obs_gyane_data?.pregnancy_risk_factor_management_remarks || null;

					await this.setState({
						pregnancy_risk_factor : pregnancy_risk_factor_selected,
						pregnancy_risk_factor_selected : pregnancy_risk_factor_selected,
						pregnancy_risk_factor_management_remarks : pregnancy_risk_factor_management_remarks,
					});

					// Cache the loaded values so componentDidUpdate can re-apply them if the ANC
					// <Form> remounts after this load (the form is gated by the pregnancy flag and
					// may mount/remount on a later render cycle). Without this, a form instance
					// created after this sync would start with an empty store and the Risk Factors
					// + Remarks would appear blank even though the data loaded.
					this._ancRiskFactorFormValues = {
						pregnancy_risk_factor : pregnancy_risk_factor_selected,
						pregnancy_risk_factor_selected : pregnancy_risk_factor_selected,
						pregnancy_risk_factor_management_remarks : pregnancy_risk_factor_management_remarks,
					};

					this.syncAncFormFields(this._ancRiskFactorFormValues);
				}     
			}
			else
			{
				// Not currently pregnant (no data, or pregnancy closed): clear the current
				// pregnancy data so the current ANC/pregnancy section stops rendering.
				await this.setState({ currentPregnancyData : null });
			}
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

  	getPatientAncDetails = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      reference_id: parseInt(LS_SERVICE.get('call_patient_qms_token_id')),
	      reference_type: 0,
	      hospital_id: parseInt(LS_SERVICE.get('FACILITY_ID')),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	      source: 'OP',
	    }
	    await Axios.post(Get_Anc_Details,Params).then(async res => {
			if(res.data.status == true)
			{
				let anc_details_data = res.data?.data;
		        if(anc_details_data)
		        {
		        	// The ANC card id is used to key the Investigations (test/procedure) results.
		        	await this.setState({ anc_id: anc_details_data?.id || null });
		        	// Load the ANC-scoped Mother Parameter + Fetus data (latest 5 by default).
		        	this.fetchAncMotherData(false);
		        	// The vaccine checklist is always built from the vaccine config (getVaccineData);
		        	// the actual given/saved data comes from the shared Vaccination Record fetch
		        	// (getSavedVaccinationRecords), NOT from the ANC saved blob. This keeps the ANC
		        	// list in sync with the Vaccination Record page.
		        	await this.getVaccineData();
                    
					// Title/Description rows come back from the backend as `test_procedures_data`
					// (patient_obs_gyane_anc_test_procedure_data). Fall back to a single empty row.
					const loadedTestProcedureDatas = Array.isArray(anc_details_data?.test_procedures_data) && anc_details_data.test_procedures_data.length > 0
						? anc_details_data.test_procedures_data.map(row => ({ id: row.id, title: row.title || '', description: row.description || '', created_by: row.created_by || null }))
						: [{ title: '', description: '' }];

					await this.setState({
						immuno_remarks : anc_details_data?.immuno_remarks || null,
						investigation_remarks : anc_details_data?.investigation_remarks || null,
						test_procedures_data : loadedTestProcedureDatas,
						pregnancy_year : anc_details_data?.pregnancy_year || null,
						delivery_mode : anc_details_data?.delivery_mode || null,
						pregnancy_type : anc_details_data?.pregnancy_type || null,
						delivery_indication_for_c_section : anc_details_data?.delivery_indication_for_c_section || null,
						delivery_details : anc_details_data?.delivery_details || null,
					});

                    setTimeout(() => {
    					this.ancFormRef?.current?.setFieldsValue({
    						immuno_remarks : anc_details_data?.immuno_remarks || null,
    						pregnancy_year : anc_details_data?.pregnancy_year || null,
    						delivery_mode : anc_details_data?.delivery_mode || null,
    						pregnancy_type : anc_details_data?.pregnancy_type || null,
    						delivery_indication_for_c_section : anc_details_data?.delivery_indication_for_c_section || null,
    						delivery_details : anc_details_data?.delivery_details || null,
    					});
                    }, 0);
		        }

		        if(anc_details_data?.pregnancy_type == '2')
		        {
		        	let saved_multiple_pregnancies = [];
		        	if(anc_details_data?.multiple_pregnancies.length > 0)
		        	{
		        		anc_details_data?.multiple_pregnancies.forEach(ele => {
			              let obj = { delivery_type : ele.delivery_type, delivery_place : ele.delivery_place, delivery_outcome : ele.delivery_outcome, delivery_bith_date_time : ele.delivery_bith_date_time != null ? moment(ele.delivery_bith_date_time) : null, delivery_gender : ele.delivery_gender, delivery_birth_weight : ele.delivery_birth_weight, delivery_birth_height : ele.delivery_birth_height, delivery_birth_head_cc : ele.delivery_birth_head_cc, delivery_congenital_abnormality : ele.delivery_congenital_abnormality == "true" ? true : false, delivery_congenital_abnormality_remarks : ele.delivery_congenital_abnormality_remarks }
			              saved_multiple_pregnancies.push(obj);
			            });
		        	}
		        	await this.setState({
			            multiple_pregnancies : saved_multiple_pregnancies
		          	});

                    setTimeout(() => {
    		          	this.ancFormRef?.current?.setFieldsValue({
    			            multiple_pregnancies : saved_multiple_pregnancies
    		          	});
                    }, 0);
		        }
		        else
		        {
		        	await this.setState({
			            delivery_type : anc_details_data?.delivery_type || null,
			            delivery_place : anc_details_data?.delivery_place || null,
			            delivery_outcome : anc_details_data?.delivery_outcome || null,
			            delivery_bith_date_time : (anc_details_data?.delivery_bith_date_time && anc_details_data.delivery_bith_date_time != null) ? moment(anc_details_data.delivery_bith_date_time).format('YYYY-MM-DD HH:mm'): null,
			            delivery_gender : anc_details_data?.delivery_gender || null,
			            delivery_birth_weight : anc_details_data?.delivery_birth_weight || null,
			            delivery_birth_height : anc_details_data?.delivery_birth_height || null,
			            delivery_birth_head_cc : anc_details_data?.delivery_birth_head_cc || null,
			            delivery_congenital_abnormality_remarks : (anc_details_data?.delivery_congenital_abnormality == "true" && (anc_details_data?.delivery_congenital_abnormality_remarks != null && anc_details_data?.delivery_congenital_abnormality_remarks != "")) ? anc_details_data?.delivery_congenital_abnormality_remarks : null,
			            delivery_congenital_abnormality : anc_details_data?.delivery_congenital_abnormality == "true" ? true : false,
			            multiple_pregnancies: [],
		          	});

                    setTimeout(() => {
    					this.ancFormRef?.current?.setFieldsValue({
    						delivery_type : anc_details_data?.delivery_type || null,
    			            delivery_place : anc_details_data?.delivery_place || null,
    			            delivery_outcome : anc_details_data?.delivery_outcome || null,
    			            delivery_bith_date_time : (anc_details_data?.delivery_bith_date_time && anc_details_data.delivery_bith_date_time != null) ? moment(anc_details_data.delivery_bith_date_time) : null,
    			            delivery_gender : anc_details_data?.delivery_gender || null,
    			            delivery_birth_weight : anc_details_data?.delivery_birth_weight || null,
    			            delivery_birth_height : anc_details_data?.delivery_birth_height || null,
    			            delivery_birth_head_cc : anc_details_data?.delivery_birth_head_cc || null,
    			            delivery_congenital_abnormality_remarks : (anc_details_data?.delivery_congenital_abnormality == "true" && (anc_details_data?.delivery_congenital_abnormality_remarks != null && anc_details_data?.delivery_congenital_abnormality_remarks != "")) ? anc_details_data?.delivery_congenital_abnormality_remarks : null,
    			            delivery_congenital_abnormality : anc_details_data?.delivery_congenital_abnormality == "true" ? true : false,
    			            multiple_pregnancies: [],
    					});
                    }, 0);
		        }
			}
			else
	        {
	        	// No OPEN ANC card (e.g. the pregnancy was just closed). Clear the current-card
	        	// state so the closed pregnancy's details stop showing without a manual reload.
	        	// Also clear currentPregnancyData so the current-pregnancy section (mother
	        	// parameters / fetus details) is hidden for a closed pregnancy. This is the
	        	// authoritative place to hide it (based on the open-ANC-card status), replacing
	        	// the previous reliance on the volatile PATIENT_PREGNANT_STATUS flag in
	        	// getPatientObsGyaneData which caused intermittent non-rendering on first load.
	        	await this.setState({
	        		anc_id: null,
	        		currentPregnancyData : null,
	        		pregnancy_year : null,
	        		delivery_mode : null,
	        		pregnancy_type : null,
	        		delivery_type : null,
	        		delivery_place : null,
	        		delivery_outcome : null,
	        		delivery_bith_date_time : null,
	        		delivery_gender : null,
	        		delivery_birth_weight : null,
	        		delivery_birth_height : null,
	        		delivery_birth_head_cc : null,
	        		delivery_congenital_abnormality : false,
	        		delivery_congenital_abnormality_remarks : null,
	        		delivery_indication_for_c_section : null,
	        		delivery_details : null,
	        		multiple_pregnancies : [],
	        	});
	        	await this.getVaccineData();
	        }
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

  	getPatientAncPreviousDetails = async () => {
	    let Params = {
	      patient_id: parseInt(LS_SERVICE.get('PATIENT_REG_DATA').registrationid),
	      enterprise_id: parseInt(LS_SERVICE.get('ENTERPRISE_ID')),
	    }
	    await Axios.post(Get_Anc_Previous_Details,Params).then(async res => {
			if(res.data.status == true)
			{
				await this.setState({
					prevAncCardData : res.data.data
				})
			}
			else
			{
				await this.setState({
					prevAncCardData : []
				})
			}
	    })
	    .catch(error => {
	      notification.error({
	        message: 'Something went wrong! Unable to fetch the data',
	        placement: 'topRight'
	      })
	    })
  	}

    getPreviousMotherHistory = async () => {
        const patient_id = parseInt(LS_SERVICE.get('PATIENT_REG_DATA')?.registrationid);
        if (!Number.isInteger(patient_id) || patient_id <= 0) {
            return;
        }

        try {
            const response = await Axios.post(Get_Previous_Mother_Fetus_History, { patient_id });
            if (response?.data?.status === true) {
                const history = response.data.data || {};
                await this.setState({
                    previousMotherParameters: Array.isArray(history.mother_parameter_data_all)
                        ? history.mother_parameter_data_all
                        : [],
                    previousMotherFetusData: Array.isArray(history.mother_fetus_data)
                        ? history.mother_fetus_data
                        : [],
                });
            } else {
                await this.setState({ previousMotherParameters: [], previousMotherFetusData: [] });
            }
        } catch (error) {
            notification.error({
                message: 'Something went wrong! Unable to fetch previous mother history',
                placement: 'topRight'
            });
        }
    };

    openPreviousMotherParameterHistory = async () => {
        await this.getPreviousMotherHistory();
        this.setState({ previousMotherParameterModalVisible: true });
    };

    openPreviousMotherFetusHistory = async () => {
        await this.getPreviousMotherHistory();
        this.setState({ previousMotherFetusModalVisible: true });
    };

    // True only when No. of Fetus holds a valid value (1-9). Used to gate the
    // "+ FETAL PARAMETER" button and the Close Pregnancy action.
    hasNoOfFetus = () => {
        const value = this.state.currentPregnancyData?.no_of_fetus;
        return /^[1-9]$/.test(String(value ?? '').trim());
    };

    // Close Pregnancy guard: No. of Fetus must be filled before closing the pregnancy.
    // Blocks opening the Delivery Details modal and prompts the user when it is blank.
    handleClosePregnancy = () => {
        // Open the Delivery Details popup directly. The modal fetches the data it needs on
        // mount (obs/gynae snapshot, ANC details, allergies/conditions), so there's no need to
        // refresh the page here — doing so caused a visible page reload before the popup opened.
        const fetusFilled = this.hasNoOfFetus();
        if (!fetusFilled) {
            notification.error({
                message: 'Please fill No. of Fetus value first to close the pregnancy.',
                placement: 'topRight'
            });
            return;
        }
        this.setState({ deliveryDetailsModalVisible: true });
    };

   getListValue(selectedValue, OptionObj = null) {
        if (selectedValue == 0 || selectedValue === null) {
            return "-";
        } else if (OptionObj) {
            return OptionObj[selectedValue];
        } else {
            return selectedValue;
        }
    }

  	// Renders every mother-parameter reading for this reference id (oldest first).
  	// Uses mother_parameter_data_all when present; falls back to the single latest object.
  	// Fetches ANC-scoped Mother Parameter + Fetus data by anc_id. `all` (from "Load more")
  	// returns every row; the default returns the latest 5 of each. "Print all" flags come
  	// back too so the checkboxes reflect saved state.
  	fetchAncMotherData = async (all = false) => {
        const anc_id = this.state.anc_id;
        if (!anc_id) {
            this.setState({ ancMotherParameters: [], ancMotherParamTotal: 0, ancMotherFetusRows: [], ancMotherFetusBatchTotal: 0 });
            return;
        }
        this.setState({ ancMotherDataLoading: true });
        try {
            const res = await Axios.post(Get_Anc_Mother_Data_By_Anc, { anc_id: parseInt(anc_id), all: all ? 'true' : 'false' });
            if (res.data && res.data.status) {
                const d = res.data.data || {};
                this.setState({
                    ancMotherParameters: Array.isArray(d.mother_parameter_data) ? d.mother_parameter_data : [],
                    ancMotherParamTotal: d.mother_parameter_total || 0,
                    ancMotherFetusRows: Array.isArray(d.mother_fetus_data) ? d.mother_fetus_data : [],
                    ancMotherFetusBatchTotal: d.mother_fetus_batch_total || 0,
                    // "expanded" is true when the backend already returned every row for that
                    // module (because `all` was requested OR the module's print_all is on).
                    // The UI hides "Load more" when expanded.
                    ancMotherParamShowAll: !!d.mother_parameter_expanded,
                    ancMotherFetusShowAll: !!d.mother_fetus_expanded,
                    ancMotherParamPrintAll: String(d.mother_parameter_print_all) === '1',
                    ancMotherFetusPrintAll: String(d.mother_fetus_print_all) === '1',
                });
            }
        } catch (err) {
            // Non-blocking: leave existing data on failure.
        } finally {
            this.setState({ ancMotherDataLoading: false });
        }
    }

  	// Persists a module's "Print all" checkbox (print-only; does not change what's shown).
  	toggleMotherPrintAll = async (module, checked) => {
        const anc_id = this.state.anc_id;
        if (!anc_id) return;
        // Optimistic UI.
        if (module === 'mother_parameter') this.setState({ ancMotherParamPrintAll: checked });
        else this.setState({ ancMotherFetusPrintAll: checked });
        try {
            await Axios.post(Save_Anc_Mother_Print_All, { anc_id: parseInt(anc_id), module, print_all: checked ? '1' : '0' });
            // Checking "Print all" expands the table to all rows by default; unchecking
            // collapses it back to the latest 5. Re-fetch to reflect that immediately.
            this.fetchAncMotherData(false);
        } catch (err) {
            // Revert on failure.
            if (module === 'mother_parameter') this.setState({ ancMotherParamPrintAll: !checked });
            else this.setState({ ancMotherFetusPrintAll: !checked });
            notification.error({ message: 'Unable to update Print all.', placement: 'topRight' });
        }
    }

  	showMotherParametersRows() {
        // ANC-scoped rows (latest-first) fetched by anc_id. No more "current pregnancy" snapshot.
        const orderedRows = Array.isArray(this.state.ancMotherParameters) ? this.state.ancMotherParameters : [];
        if (orderedRows.length === 0) {
            return (<tr><td className="text-center" colSpan="11">No data available</td></tr>);
        }
        return orderedRows.map((data, i) => (
            <tr key={data.id || i}>
                <td className="text-center">
                    {(data.updatedAt || data.createdAt) ? moment(data.updatedAt || data.createdAt).format("D MMM, YYYY | h:mm A") : '-'}
                    {data.mother_remarks && data.mother_remarks !== null ? (
                        <Tooltip title={data.mother_remarks}>
                            <InfoCircleOutlined style={{ cursor: 'pointer', color: '#1a73e8', fontSize: '14px', marginLeft: '6px' }} />
                        </Tooltip>
                    ) : null}
                </td>
                <td className="text-center">{data.saved_by_doctor_name || '-'}</td>
                <td className="text-center">{data.pog || '-'}</td>
                <td className="text-center">{data.weight || '-'}</td>
                <td className="text-center">{data.blood_pressure || '-'}</td>
                <td className="text-center">{data.pulse_rate || '-'}</td>
                <td className="text-center">{data.fundal_height || '-'}</td>
                <td className="text-center">{data.edema || '-'}</td>
                <td className="text-center">{data.pallor || '-'}</td>
                <td className="text-center">{data.cervix_exam || '-'}</td>
                <td className="text-center">{data.preterm_labour || '-'}</td>
            </tr>
        ));
    }

  	// Renders a SEPARATE table per fetus_no: one table for Fetus 1, another for Fetus 2, etc.
  	// Within each table the records are shown latest first (highest id on top).
  	showFetalParameterTables() {
        const rows = Array.isArray(this.state.ancMotherFetusRows) ? this.state.ancMotherFetusRows : [];
        if (rows.length === 0) {
            return (
                <div className='row mt-3'>
                    <table className="table table-bordered mt-2">
                        <tbody>
                            <tr><td className="text-center">No data available</td></tr>
                        </tbody>
                    </table>
                </div>
            );
        }

        // Group rows by fetus_no (fall back to 1 when missing).
        const groups = {};
        rows.forEach((r) => {
            const key = (r.fetus_no != null && r.fetus_no !== '') ? parseInt(r.fetus_no) : 1;
            if (!groups[key]) groups[key] = [];
            groups[key].push(r);
        });

        const fetusNos = Object.keys(groups).map(k => parseInt(k)).sort((a, b) => a - b);

        return fetusNos.map((fno) => {
            // Latest saved first within this fetus.
            const fetusRows = [...groups[fno]].sort((a, b) => (b.id || 0) - (a.id || 0));
            return (
                <div className='row mt-3' key={'fetus-' + fno}>
                    <div className='col-12'>
                        <span className='title'>{'Fetus ' + fno}</span>
                    </div>
                    <table className="table table-bordered mt-2">
                        <thead>
                            <tr>
                                <td width="12%">DATE &amp; TIME</td>
                                <td width="12%">SAVED BY</td>
                                <td width="11%">FETAL MOVEMENT</td>
                                <td width="9%">FHR(B/Min)</td>
                                <td width="11%">PRESENTATION</td>
                                <td width="11%">RELATION OF PP TO BRIM</td>
                                <td width="9%">HEAD CC (CM)</td>
                                <td width="9%">ABDOMINAL CC (CM)</td>
                                <td width="9%">FEMUR LENGTH(CM)</td>
                            </tr>
                        </thead>
                        <tbody>
                            {fetusRows.map((data, i) => (
                                <tr key={data.id || i}>
                                    <td className="text-center">{(data.updatedAt || data.createdAt) ? moment(data.updatedAt || data.createdAt).format("D MMM, YYYY | h:mm A") : '-'}</td>
                                    <td className="text-center">{data.saved_by_doctor_name || '-'}</td>
                                    <td className="text-center">{this?.getListValue(data.fetal_movement, FETAL_MOVEMENT)}</td>
                                    <td className="text-center">{data.fetal_heart_rate || '-'}</td>
                                    <td className="text-center">{this?.getListValue(data.presentation, PRESENTATION)}</td>
                                    <td className="text-center">{this?.getListValue(data.relationship_of_pp_to_brim, RELATIONSHIP_TO_PP_BRIM)}</td>
                                    <td className="text-center">{data.head_cc || '-'}</td>
                                    <td className="text-center">{data.abdominal_cc || '-'}</td>
                                    <td className="text-center">{data.femur_length || '-'}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            );
        });
    }
    
    render() {
    	const { patientInfo } = this.state;
    	const { ss_configuration, consult_type, prevAncCardData } = this.state;
        const cpd = this.state.currentPregnancyData;
        const headerLmp = cpd?.menstural_data?.lmp || null;
        const headerEdd = cpd?.edd_by_lmp || null;
        const headerCorrectedEdd = cpd?.corrected_edd || null;
        const headerObstetric = cpd?.obstetric_data;
        // Full GPALE score (Gravidity, Parity, Abortion, Live birth, Ectopic).
        const headerGpale = headerObstetric
            ? [
                (headerObstetric.gravidity != null && headerObstetric.gravidity !== '') ? 'G' + headerObstetric.gravidity : '',
                (headerObstetric.parity != null && headerObstetric.parity !== '') ? 'P' + headerObstetric.parity : '',
                (headerObstetric.abortion != null && headerObstetric.abortion !== '') ? 'A' + headerObstetric.abortion : '',
                (headerObstetric.live_birth != null && headerObstetric.live_birth !== '') ? 'L' + headerObstetric.live_birth : '',
                (headerObstetric.ectopic != null && headerObstetric.ectopic !== '') ? 'E' + headerObstetric.ectopic : '',
              ].filter(Boolean).join(' ')
            : '';
        const headerGaToday = this.getGAToday(headerLmp, headerEdd, headerCorrectedEdd);
        // Show Pregnancy Active / Close Pregnancy based on the PATIENT-level flag, which is
        // set to 0 when the pregnancy is closed (delivery details saved). Kept live via
        // pregnantService; falls back to the patient record's is_pregnant.
        const isHeaderPregnant = this.state.isPatientPregnant || this.state.patientInfo?.is_pregnant == "1";
        return (
            <>
                <AsideLeft />
                <MyHcSpeechRecognition />
                <div className="content-wrapper">
                    <div className="container-fluid emrfrm anc-container mb-4 ">
                        <div className='row'>
                            <div className='col-12 mb-3'>
                                <div className="float-left">
                                    <h1 className="page-title mb-0">ANC Card</h1>
                                </div>
                            </div>
                        </div>
                        {
                            isHeaderPregnant
                            ?
                                <div className='row'>
                                    <div className='col-12'>
                                        <div className='card p-3' style={{ backgroundColor: '#fff' }}>
                                            <div className='row align-items-center flex-nowrap'>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>LMP:&nbsp;</span>
                                                    <span className='patient_name'>{headerLmp ? moment(headerLmp).format('DD MMM, YYYY') : '-'}</span>
                                                </div>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>EDD BY LMP:&nbsp;</span>
                                                    <span className='patient_name'>{headerEdd ? moment(headerEdd).format('DD MMM, YYYY') : '-'}</span>
                                                </div>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>Gravidity:&nbsp;</span>
                                                    <span className='patient_name'>
                                                        {headerGpale !== '' ? headerGpale : '-'}
                                                    </span>
                                                </div>
                                                <div className='col-auto'>
                                                    <span className='heading font-weight-bold'>GA Today:&nbsp;</span>
                                                    <span className='patient_name' style={{ color: '#1a73e8' }}>{headerGaToday || '-'}</span>
                                                </div>
                                                <div className='col text-right'>
                                                    <button type="button" className="btn small px-3 mr-2" style={{ color: '#2e7d32', backgroundColor: '#e6f4ea', border: '1px solid #b7dfc2', cursor: 'default' }}>
                                                        <span style={{ display: 'inline-block', width: '8px', height: '8px', borderRadius: '50%', backgroundColor: '#2e7d32', marginRight: '6px' }}></span>
                                                        Pregnancy Active
                                                    </button>
                                                    <button type="button" className="btn btn-primary small px-3" onClick={this.handleClosePregnancy}>Close Pregnancy</button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            :
                            null
                        }

                        {
                        	/* Active (current) ANC card first, shown expanded on top */
                        	LS_SERVICE.get('PATIENT_PREGNANT_STATUS') == "1" 
                        	?
                            <>
                            	<div className='row mt-3'>
                                    <div className='col-12'>
                                        <div className='card anc-carddarkgrey'>
                                            <span className='newancdet'>New ANC Card Details</span>
                                        </div>
                                    </div>
                                </div>
                                <Form
                                    layout="vertical"
                                    className="emrfrm"
                                    ref={this.ancFormRef}
                                    onFinish={this.onFinishAncForm}
                                    id="saveform"
                                >
                                	{
                                    	this.state.currentPregnancyData?.menstural_data 
                                    	?
	                                        <>
	                                            <div className='row mt-3'>
	                                                <div className='col-12'>
	                                                    <h6 className='font-weight-bold mb-0'>MENSTRUAL HISTORY</h6>
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3'>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>LMP</div>
	                                                    <div className='font-weight-bold'>
	                                                    	{(this.state.currentPregnancyData?.menstural_data?.lmp && this.state.currentPregnancyData?.menstural_data.lmp != null) ? moment(this.state.currentPregnancyData?.menstural_data.lmp).format('DD MMM, YYYY'): '-'}
                                                    	</div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>Cycle Length</div>
	                                                    <div className='font-weight-bold'>
	                                                    	{(this.state.currentPregnancyData?.menstural_data?.cycle_length != null && this.state.currentPregnancyData?.menstural_data?.cycle_length != "") ? this.state.currentPregnancyData?.menstural_data?.cycle_length + " days" : '-'}
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>GA Today</div>
	                                                    <div>
	                                                        {
	                                                            this.getGAToday(this.state.currentPregnancyData?.menstural_data?.lmp, this.state.currentPregnancyData?.corrected_edd || this.state.currentPregnancyData?.edd_by_lmp, this.state.currentPregnancyData?.corrected_edd)
	                                                            ?
	                                                                <span className='px-3 py-1 rounded font-weight-bold' style={{ backgroundColor: '#e8f0fe', color: '#1a73e8' }}>
	                                                                    {this.getGAToday(this.state.currentPregnancyData?.menstural_data?.lmp, this.state.currentPregnancyData?.corrected_edd || this.state.currentPregnancyData?.edd_by_lmp, this.state.currentPregnancyData?.corrected_edd)} {(this.state.currentPregnancyData?.corrected_edd) ? '(from Corrected EDD)' : '(from LMP)'}
	                                                                </span>
	                                                            :
	                                                                <span className='font-weight-bold'>-</span>
	                                                        }
	                                                    </div>
	                                                </div>
	                                                <div className='col-3'>
	                                                    <div className='text-muted mb-1'>Last Updated</div>
	                                                    <div className='font-weight-bold'>
	                                                        {this.state.currentPregnancyData?.menstural_data?.updatedAt ? moment(this.state.currentPregnancyData?.menstural_data?.updatedAt).format("D MMM, YYYY | h:mm A") : '-'}
	                                                    </div>
	                                                </div>
	                                            </div>
	                                        </>
                                        : 
                                        null
                                    }
                                    {
                                    	this.state.currentPregnancyData ?
                                        <>
                                            <div className='row mt-3'>
                                                <div className='col-12'>
                                                    <h6 className='font-weight-bold mb-0'>OBSTETRIC HISTORY</h6>
                                                </div>
                                            </div>
                                            <div className='row mt-3'>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>EDD by LMP</div>
                                                    <div className='font-weight-bold'>{this.state.currentPregnancyData?.edd_by_lmp ? moment(this.state.currentPregnancyData?.edd_by_lmp).format("D MMM, YYYY") : '-'}</div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Corrected EDD</div>
                                                    <div>
                                                        {
                                                            (this.state.currentPregnancyData?.corrected_edd != null && this.state.currentPregnancyData?.corrected_edd != "")
                                                            ?
                                                                <span className='px-3 py-1 rounded font-weight-bold text-white' style={{ backgroundColor: '#c0392b' }}>
                                                                    {moment(this.state.currentPregnancyData?.corrected_edd).format("D MMM, YYYY")}
                                                                </span>
                                                            :
                                                                <span className='font-weight-bold'>-</span>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Lactating</div>
                                                    <div className='font-weight-bold'>{(this.state?.currentPregnancyData?.lactating && this.state?.currentPregnancyData?.lactating == "1") ? 'Yes' : 'No'}</div>
                                                </div>
                                                <div className='col-3'>
                                                    <div className='text-muted mb-1'>Gravidity / Parity</div>
                                                    <div>
                                                    {
                                                        this.state?.currentPregnancyData?.obstetric_data
                                                        ?
                                                            <span className="bg-grey py-1 px-3 rounded font-weight-bold">
                                                                {(this.state?.currentPregnancyData?.obstetric_data.gravidity != null && this.state?.currentPregnancyData?.obstetric_data.gravidity !== '') ? 'G'+this.state?.currentPregnancyData?.obstetric_data.gravidity+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.parity != null && this.state?.currentPregnancyData?.obstetric_data.parity !== '') ? 'P'+this.state?.currentPregnancyData?.obstetric_data.parity+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.abortion != null && this.state?.currentPregnancyData?.obstetric_data.abortion !== '') ? 'A'+this.state?.currentPregnancyData?.obstetric_data.abortion+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.live_birth != null && this.state?.currentPregnancyData?.obstetric_data.live_birth !== '') ? 'L'+this.state?.currentPregnancyData?.obstetric_data.live_birth+' ' : ''}{(this.state?.currentPregnancyData?.obstetric_data.ectopic != null && this.state?.currentPregnancyData?.obstetric_data.ectopic !== '') ? 'E'+this.state?.currentPregnancyData?.obstetric_data.ectopic+' ' : ''}
                                                            </span>
                                                        :
                                                        <span className='font-weight-bold'>-</span>
                                                    }
                                                    </div>
                                                </div>
                                            </div>
                                            {
                                            	this.state.currentPregnancyData?.obstetric_remarks && this.state.currentPregnancyData?.obstetric_remarks != "" && this.state.currentPregnancyData?.obstetric_remarks != null 
                                            	?
		                                            <div className='row mt-3'>
		                                                <div className='col-2'>
		                                                    <span className='title'>OBSTETRIC EXAMINATION/REMARKS</span>
		                                                </div>
		                                                <div className='col-10'>
		                                                    <pre style={{ fontSize: "15px", border: "none" }}>{this.state.currentPregnancyData?.obstetric_remarks}</pre> 
		                                                </div>
		                                            </div>
                                            	: 
                                            	null
                                            }
                                        </>
                                        : 
                                        null
                                    }

                                    <div className='row mt-3'>
                                        <div className='col-12'>
                                            <span className='title'> ALLERGIES</span>
                                        </div>
                                        <table className="table table-bordered mt-3" >
                                            <thead>
                                                <tr>
                                                    <td width="28%">ALLERGY NAME</td>
                                                    <td width="22%">REACTION</td>
                                                    <td width="15%">DURATION</td>
                                                    <td width="15%">INTENSITY</td>
                                                    <td width="15%">INFORMED BY</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.current_allergies != undefined && this.state.current_allergies.length > 0 ?
                                                    this.state.current_allergies.map((obj) => (
                                                        <tr>
                                                            <td>{obj.allergy_name}</td>
                                                            <td>{obj.reaction ? obj.reaction : '-'}</td>
                                                            <td>{obj.duration ? obj.duration + ' ' + DURATION_TYPE[obj.durationType] : '-'}</td>
                                                            <td>{obj.intensity === 0 ? "Low" : obj.intensity === 1 ? "Medium" : obj.intensity === 2 ? "High" : '-'}</td>
                                                            <td>{obj?.informedBy == 0 || obj?.informedBy == 1 ? INFORMED_BY[obj?.informedBy] : "-"}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colspan="5">No data available</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>

                                    <div className='row mt-3'>
                                        <div className='col-12'>
                                            <span className='title'>EXISTING CONDITION</span>
                                        </div>
                                        <table className="table table-bordered mt-3" >
                                            <thead>
                                                <tr>
                                                    <td width="30%">CONDITIONS</td>
                                                    <td width="20%">DURATION</td>
                                                    <td width="20%">ON MEDICATION</td>
                                                    <td width="30%">MEDICINE NAME</td>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.current_conditions != undefined && this.state.current_conditions.length > 0 ?
                                                    this.state.current_conditions.map((c, i) => (
                                                        <tr>
                                                            <td>{c.condition_description}</td>
                                                            <td>{(c.duration) ? `${c.duration} ${DURATION_TYPE[c.durationType]}` : '-'}</td>
                                                            <td>{MEDICATION_ON[c.onMedication] ? MEDICATION_ON[c.onMedication] : '-'}</td>
                                                            <td>{c.medicineName || "NA"}</td>
                                                        </tr>
                                                    ))
                                                    : <tr><td colspan="4">No data available</td></tr>}
                                            </tbody>
                                        </table>
                                    </div>

                                    {/* Read-only Previous Pregnancy Details table. Self-fetches by
                                        patient_id, so it only needs the patient id (same source the
                                        obs/gynae screen passes to PreviousPregnancyModal). */}
                                    <PreviousPregnancyDetails
                                        patientId={parseInt(LS_SERVICE.get('PATIENT_REG_DATA')?.registrationid)}
                                    />
                                    {
                                    	(this.state.ancMotherParameters.length > 0 || this.state.ancMotherFetusRows.length > 0 || this.state.allowEdit)
                                    	?
	                                        <>
	                                            <div className='row mt-3'>
	                                                <div className='col-12'>
	                                                    <span className='title'> PHYSICAL EXAMINATION</span>
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3 align-items-center'>
	                                                <div className='col-4 d-flex align-items-center'>
	                                                    <span className='title'>MOTHER'S PARAMETERS</span>
	                                                </div>
	                                                <div className='col-4 text-center'>
	                                                    <Checkbox
	                                                        checked={this.state.ancMotherParamPrintAll}
	                                                        disabled={!this.state.allowEdit}
	                                                        onChange={(e) => this.toggleMotherPrintAll('mother_parameter', e.target.checked)}
	                                                    >
	                                                        Print All Mother's Parameter
	                                                    </Checkbox>
	                                                </div>
	                                                <div className='col-4 text-right'>
	                                                    {
	                                                        this.state.allowEdit
	                                                        ?
	                                                            <a className='btn btn-outline-primary small px-2' onClick={() => this.setState({ motherParameterModalVisible: true })}>
	                                                                + MOTHER'S PARAMETERS
	                                                            </a>
	                                                        :
	                                                        null
	                                                    }
	                                                </div>
	                                            </div>
	                                            <div className='row mt-3 '>
	                                                <table className="table table-bordered mt-3" >
	                                                    <thead>
	                                                        <tr>
	                                                            <td width="15%">DATE &amp; TIME</td>
	                                                            <td width="11%">SAVED BY</td>
	                                                            <td width="9%">POG (WEEKS)</td>
	                                                            <td width="5%">WEIGHT (KG)</td>
	                                                            <td width="9%">BP (MMHG)</td>
	                                                            <td width="9%">PULSE RATE (MIN)</td>
	                                                            <td width="9%">FUNDAL HT (CM)</td>
	                                                            <td width="8%">EDEMA</td>
	                                                            <td width="8%">PALLOR</td>
	                                                            <td width="8%">CERVIX EXAM</td>
	                                                            <td width="9%">PRETERM LABOUR (SIGN/SYMPTOMS)</td>
	                                                        </tr>
	                                                    </thead>
	                                                    <tbody>
	                                                    	{this.showMotherParametersRows()}
	                                                    </tbody>
	                                                </table>
	                                            </div>
	                                            {
	                                                (!this.state.ancMotherParamShowAll && this.state.ancMotherParamTotal > this.state.ancMotherParameters.length)
	                                                ?
	                                                    <div className='row'>
	                                                        <div className='col-12 text-center'>
	                                                            <a href='javascript:void(0)' className='text-primary' onClick={() => { this.setState({ ancMotherParamShowAll: true }); this.fetchAncMotherData(true); }}>
	                                                                Load more ({this.state.ancMotherParamTotal - this.state.ancMotherParameters.length} more)
	                                                            </a>
	                                                        </div>
	                                                    </div>
	                                                : null
	                                            }
	                                            <div className='row mt-3 align-items-center'>
	                                                <div className='col-4 d-flex align-items-center'>
	                                                    <span className='title'>FETAL PARAMETERS</span>
	                                                </div>
	                                                <div className='col-4 text-center'>
	                                                    <Checkbox
	                                                        checked={this.state.ancMotherFetusPrintAll}
	                                                        disabled={!this.state.allowEdit}
	                                                        onChange={(e) => this.toggleMotherPrintAll('mother_fetus', e.target.checked)}
	                                                    >
	                                                        Print All Fetal Parameters
	                                                    </Checkbox>
	                                                </div>
	                                                <div className='col-4 text-right'>
	                                                    {
	                                                        this.state.allowEdit && this.hasNoOfFetus()
	                                                        ?
	                                                            <a className='btn btn-outline-primary small px-2' onClick={() => this.setState({ fetusModalVisible: true })}>
	                                                                + FETAL PARAMETERS
	                                                            </a>
	                                                        :
	                                                        null
	                                                    }
	                                                </div>
	                                            </div>
	                                            {this.showFetalParameterTables()}
	                                            {
	                                                (!this.state.ancMotherFetusShowAll && this.state.ancMotherFetusBatchTotal > this.state.ancMotherFetusRows.length)
	                                                ?
	                                                    <div className='row'>
	                                                        <div className='col-12 text-center'>
	                                                            <a href='javascript:void(0)' className='text-primary' onClick={() => { this.setState({ ancMotherFetusShowAll: true }); this.fetchAncMotherData(true); }}>
	                                                                Load more
	                                                            </a>
	                                                        </div>
	                                                    </div>
	                                                : null
	                                            }
	                                        </>
                                        : 
                                        null
                                    }
                                    <VaccineOptional
                                        vaccineData={this.state.vaccineData}
                                        vaccineItemList={this.state.vaccineItemList}
                                        vaccinationSites={this.state.vaccinationSites}
                                        patientDob={this.state.patientInfo?.dob || null}
                                        allowEdit={this.state.allowEdit}
                                        onVaccineDate={this.handleVaccineDate}
                                        onGivenOutside={this.handleVaccineGivenOutside}
                                        onFieldChange={this.handleVaccineFieldChange}
                                        onSelectChange={this.handleVaccineSelectChange}
                                        onExpiryDate={this.handleVaccineExpiryDate}
                                        onAddDose={this.handleVaccineAddDose}
                                        disabledPastDate={this.disabledPastDate}
                                    />

                                    {/* Investigations (Test & Procedure Results + Title/Description rows) - separate component keyed by anc_id */}
                                    <AncTestProcedures
                                        anc_id={this.state.anc_id}
                                        patient_id={parseInt(LS_SERVICE.get('PATIENT_REG_DATA')?.registrationid)}
                                        facility_id={parseInt(LS_SERVICE.get('FACILITY_ID'))}
                                        enterprise_id={parseInt(LS_SERVICE.get('ENTERPRISE_ID'))}
                                        encounter_id={parseInt(LS_SERVICE.get('PATIENT_ENCOUNTER_ID') || 0)}
                                        allowEdit={this.state.allowEdit}
                                        testProcedureRows={this.state.test_procedures_data}
                                        onTestProcedureRowsChange={(rows) => this.setState({ test_procedures_data: rows })}
                                    />

                                	<div className='row d-flex align-items-start mt-4 mb-4'>
                                        <div className='col-6'>
                                            <div className="antSelectItem hasdata mb-0">
                                                {/* STATE-controlled Select: Form.Item has NO `name`, so antd does
                                                    not take over the value via the form store. Value comes from
                                                    this.state.pregnancy_risk_factor_selected and changes go through
                                                    handleOnPregnancyRiskFactorChange -> setState. This removes the
                                                    form-store/state dual-control race that made the field blank on
                                                    landing and ignore user changes. */}
                                                <Form.Item
                                                    label="Pregnancy risk factors"
                                                    className='mb-0'
                                                >
                                                    <Select
                                                        showSearch
                                                        mode="multiple"
                                                        value={this.state.pregnancy_risk_factor_selected}
                                                        notFoundContent={null}
                                                        filterOption={true}
                                                        disabled={!this.state.allowEdit}
                                                        onChange={this.handleOnPregnancyRiskFactorChange}
                                                        style={{ width: '100%', minHeight: '40px' }}
                                                        optionFilterProp="children"
                                                    >
                                                        {this.optionRiskFactorsLoad()}
                                                    </Select>
                                                </Form.Item>
                                            </div>
                                        </div>
                                        <div className='col-6'>
                                            <div className={`form-group antInputItem micwrap hasdata mb-0`}>
                                                <Link
                                                    onClick={(e) => {
                                                        e.preventDefault(); this.initSpeech({ identifier: "pregnancy_risk_factor_management_remarks" });
                                                    }}
                                                    className={
                                                        this.state.speech.identifier === "pregnancy_risk_factor_management_remarks" && this.state.speech.state ? "mic subjective-mic on mute" : "mic subjective-mic"
                                                    }
                                                ></Link>
                                                {/* STATE-controlled TextArea: Form.Item has NO `name` so antd
                                                    won't override value via the form store; value is
                                                    this.state.pregnancy_risk_factor_management_remarks and edits go
                                                    through handleOnTextChange -> setState. */}
                                                <Form.Item
                                                    className='mb-0'
                                                >
                                                    <Input.TextArea
                                                        className="form-control diagnosis_notes_class speech-field"
                                                        id="pregnancy_risk_factor_management_remarks"
                                                        name="pregnancy_risk_factor_management_remarks"
                                                        autoSize={{ minRows: 1.3, maxRows: 6 }}
                                                        maxLength={255}
                                                        disabled={!this.state.allowEdit}
                                                        style={{ minHeight: '40px' }}
                                                        onInput={(e) => this.autoHeight(e)}
                                                        onChange={this.handleOnTextChange}
                                                        value={this.state.pregnancy_risk_factor_management_remarks}
                                                    />
                                                </Form.Item>
                                                <label htmlFor="pregnancy_risk_factor_management_remarks">Pregnancy Risk Factor / Remarks</label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='row mt-3 mb-5'>
                                        <div className='col-12 text-center'>
                                            <Form.Item>
                                                <button onClick={() => this.printAncDetails()} type="button" className="btn btn-primary px-5 mr-3">Print {this.state.isPrintLoader ? LOADER : null}</button>
                                                <button htmlType="submit" className="btn btn-primary px-5 ml-3" disabled={this.state.spin_loading}>SAVE {this.state.spin_loading ? LOADER : null}</button>
                                            </Form.Item>
                                        </div>
                                    </div>
                                </Form>
                            </>
                            :
                            null
                        }

                        {
                        	/* Previous (closed) ANC cards below the active one, in collapsed state */
                        	prevAncCardData.length > 0  
                        	?
                            	prevAncCardData.map((obj, index) => {
	                                return (
	                                    <AncCardView
                                            ref={this.createRef}
                                            patientInfo={patientInfo}
                                            AncCardData={obj}
                                            index={index}
                                            riskFactorsOptions={this.state.risk_factors_options}
                                        />
	                                );
                            	})
                            : 
                            null
                        }
                    </div>
                </div >

                {/* Close Pregnancy -> Delivery Details modal */}
                {
                    this.state.deliveryDetailsModalVisible
                    ?
                        <DeliveryDetailsModal
                            visible={this.state.deliveryDetailsModalVisible}
                            allowEdit={this.state.allowEdit}
                            onClose={() => this.setState({ deliveryDetailsModalVisible: false })}
                            /* Save the ANC card data FIRST when closing the pregnancy, so the
                               latest ANC edits are always persisted before the delivery/close
                               save. Returns false if the ANC save was aborted (e.g. vaccine
                               validation failed), which stops the pregnancy from being closed. */
                            onBeforeSave={() => this.onFinishAncForm("close_pregnancy")}
                            /* Closing the pregnancy (saving delivery details) also moves the
                               current pregnancy into the patient's history, so refresh the
                               "Previous ANC" data and mother/fetus history too — not just the
                               current ANC/obs-gynae/patient data — so the page reflects it
                               without a manual reload. */
                            onSaved={() => { this.getPatientAncDetails(); this.getPatientObsGyaneData(); this.getPatientData(); this.getPatientAncPreviousDetails(); this.getPreviousMotherHistory(); }}
                        />
                    :
                    null
                }

                {/* + Mother Parameter -> add a new mother-parameter record for this visit */}
                {
                    this.state.motherParameterModalVisible
                    ?
                        <MotherParameterModal
                            visible={this.state.motherParameterModalVisible}
                            allowEdit={this.state.allowEdit}
                            lmp={this.state.currentPregnancyData?.menstural_data?.lmp || null}
                            onClose={() => this.setState({ motherParameterModalVisible: false })}
                            onSaved={() => { this.getPatientObsGyaneData(); this.fetchAncMotherData(this.state.ancMotherParamShowAll); }}
                        />
                    :
                    null
                }

                {/* + Fetus -> add/update a fetus record (by fetus_no) for this visit */}
                {
                    this.state.fetusModalVisible
                    ?
                        <FetusModal
                            visible={this.state.fetusModalVisible}
                            allowEdit={this.state.allowEdit}
                            noOfFetus={this.state.currentPregnancyData?.no_of_fetus || null}
                            existingFetusData={this.state.ancMotherFetusRows || []}
                            onClose={() => this.setState({ fetusModalVisible: false })}
                            onSaved={() => { this.getPatientObsGyaneData(); this.fetchAncMotherData(this.state.ancMotherFetusShowAll); }}
                        />
                    :
                    null
                }

                {/* Patient-level read-only mother and fetus histories, across all references */}
                {
                    this.state.previousMotherParameterModalVisible
                    ?
                        <PreviousMotherHistoryModal
                            visible={this.state.previousMotherParameterModalVisible}
                            type="mother"
                            motherParameters={this.state.previousMotherParameters}
                            motherFetusData={this.state.previousMotherFetusData}
                            onClose={() => this.setState({ previousMotherParameterModalVisible: false })}
                        />
                    : null
                }
                {
                    this.state.previousMotherFetusModalVisible
                    ?
                        <PreviousMotherHistoryModal
                            visible={this.state.previousMotherFetusModalVisible}
                            type="fetus"
                            motherParameters={this.state.previousMotherParameters}
                            motherFetusData={this.state.previousMotherFetusData}
                            onClose={() => this.setState({ previousMotherFetusModalVisible: false })}
                        />
                    : null
                }

                {/* Modal For Multiple Pregnancies */}
                <Modal
                    title="Multiple Pregnancy Details"
                    destroyOnClose={true}
                    visible={this.state.multiplePregnanciesModal}
                    onCancel={(e) =>
                        this.handleModalPopup(e, "multiplePregnanciesModal")
                    }
                    width="1800px"
                    bodyStyle={{ paddingBottom: "15px" }}
                    className="emrfrm"
                    footer={false}
                >
                    {this.state.multiplePregnanciesModal ?
                        <MultiplePregnancies
                            allowEdit={this.state.allowEdit}
                            multiple_pregnancies={this.state.multiple_pregnancies}
                            handleModalSave={this.handleModalSave}
                        />
                        : null}
                </Modal>

                <Modal
                    title="Anc Details"
                    visible={this.state.showRxModal}
                    footer={false}
                    width={850}
                    onCancel={() => { this.setState({ showRxModal: false, rxPdfPath: null }) }}
                    style={{ top: 20 }}
                >
                    <div className="row">
                        <div className="col-12 my-3 text-center">
                            <iframe src={this.state.rxPdfPath} frameBorder="0" scrolling="no" style={{ overflow: 'hidden' }} width="100%" height="700"></iframe>
                        </div>
                    </div>
                </Modal>
            </>
        )
    }
}
